
export interface ElementoFattoType {
    id: string;
    category: 'GENERICO' | 'AMBITO PRIVATO' | 'AMBITO AZIENDALE' | 'BONIFICHE' | 'STUDI LEGALI' | 'ATTIVITA DI CONSULENZA';
    label: string;
    mandatiCollegati: string[],
    text: string;
}

export const elementiFattoList: ElementoFattoType[] = [
    // --- Formule generiche (sempre visibili) ---
    {
        id: 'GEN-01',
        category: 'GENERICO',
        label: 'Formula Generica 1 (Elementi confidenziali)',
        mandatiCollegati: ['PR01','PR02','PR03','PR04','PR05','PR06','PR07','PR08','PR09','PR10','PR12','PR13','PR14','PR22','PR99', 'AZ01','AZ02','AZ03','AZ04','AZ05','AZ07','AZ10','AZ12','AZ14','AZ99', 'BF01','BF02','BF03','BF04','BF99','SL01','SL02','SL03','SL05','SL99','CO01','CO06','CO99'],
        text: "Il Mandante dichiara di essere in possesso di elementi di fatto, anche di natura confidenziale, tali da \n" +
            "giustificare la richiesta di indagini investigative, come meglio descritto nell’oggetto del presente \n" +
            "mandato."
    },
    {
        id: 'GEN-02',
        category: 'GENERICO',
        label: 'Formula Generica 2',
        mandatiCollegati: ['PR01','PR02','PR03','PR04','PR05','PR06','PR07','PR08','PR09','PR10','PR12','PR13','PR14','PR22','PR99', 'AZ01','AZ02','AZ03','AZ04','AZ05','AZ07','AZ10','AZ12','AZ14','AZ99', 'BF01','BF02','BF03','BF04','BF99','SL01','SL02','SL03','SL05','SL99','CO01','CO06','CO99'],
        text: "Il Mandante riferisce di aver rilevato circostanze, comportamenti e informazioni che, nel loro \n" +
            "complesso, fanno sorgere un fondato sospetto di condotte potenzialmente lesive dei propri diritti e \n" +
            "interessi, come specificato nell’oggetto del presente incarico. "
    },
    {
        id: 'GEN-03',
        category: 'GENERICO',
        label: 'Formula Generica 3',
        mandatiCollegati: ['PR01','PR02','PR03','PR04','PR05','PR06','PR07','PR08','PR09','PR10','PR12','PR13','PR14','PR22','PR99', 'AZ01','AZ02','AZ03','AZ04','AZ05','AZ07','AZ10','AZ12','AZ14','AZ99', 'BF01','BF02','BF03','BF04','BF99','SL01','SL02','SL03','SL05','SL99','CO01','CO06','CO99'],
        text: "Il Mandante dichiara che la presente richiesta di indagini trae origine da fatti, situazioni e \n" +
            "segnalazioni pregresse che ritiene rilevanti ai fini della tutela dei propri diritti in sede giudiziaria e \n" +
            "stragiudiziale."
    },

    // --- AMBITO PRIVATO ---
    {
        id: 'PR01-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR01'],
        text: `Il Mandante dichiara di aver rilevato, da un periodo significativo, un marcato mutamento nelle abitudini del coniuge, con frequenti assenze e rientri in orari difformi rispetto al consueto, accompagnati da giustificazioni generiche o non verificabili.`
    },
    {
        id: 'PR01-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR01'],
        text: `Il Mandante riferisce di aver riscontrato un incremento della riservatezza del coniuge nella gestione delle comunicazioni e dei propri spostamenti (es. uso del telefono, chat, social), nonché atteggiamenti di occultamento o reticenza non presenti in precedenza.`
    },
    {
        id: 'PR01-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR01'],
        text: `Il Mandante segnala di aver appreso informazioni riservate e/o di aver riscontrato circostanze oggettive (contatti ricorrenti, frequentazioni, incontri) compatibili con l’ipotesi di una relazione extraconiugale, ritenute meritevoli di riscontro.`
    },
    {
        id: 'PR01-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR01'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto, anche di natura confidenziale, che nel loro complesso fanno sorgere un fondato sospetto circa condotte del coniuge potenzialmente lesive dei propri diritti, rendendo necessario un accertamento investigativo.`
    },
    {
        id: 'PR01-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR01'],
        text: `Il Mandante dichiara che, a partire da __________________, ha rilevato i seguenti elementi di fatto: __________________ (es. assenze, rientri anomali, contatti sospetti, cambiamenti improvvisi nelle abitudini), tuttora in corso / ripetuti nel tempo, e chiede riscontri oggettivi sulla condotta del coniuge.`
    },
    {
        id: 'PR02-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR02'],
        text: `Il Mandante dichiara di aver rilevato un mutamento significativo nella condotta del partner convivente, con assenze frequenti, rientri in orari atipici e progressiva riduzione della partecipazione alla vita comune, accompagnati da spiegazioni generiche o non verificabili.`
    },
    {
        id: 'PR02-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR02'],
        text: `Il Mandante riferisce di aver riscontrato una crescente riservatezza del partner nella gestione di comunicazioni e spostamenti (telefono, chat, social, geolocalizzazione), nonché comportamenti di occultamento o reticenza non presenti in precedenza.`
    },
    {
        id: 'PR02-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR02'],
        text: `Il Mandante segnala circostanze oggettive e/o informazioni riservate compatibili con l’ipotesi di una relazione parallela o di condotte comunque idonee a pregiudicare la sfera personale e/o patrimoniale del Mandante (es. frequentazioni ricorrenti, incontri, gestione anomala di denaro o spese).`
    },
    {
        id: 'PR02-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR02'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, nel loro complesso, fanno sorgere un fondato sospetto circa condotte del partner convivente potenzialmente lesive dei propri diritti e interessi, rendendo necessario un accertamento investigativo.`
    },
    {
        id: 'PR02-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR02'],
        text: `Il Mandante dichiara che, con riferimento al partner convivente __________________, a partire da __________________, ha rilevato i seguenti elementi di fatto: __________________ (es. assenze, rientri anomali, contatti sospetti, spese/condotte anomale), tuttora in corso / ripetuti nel tempo, e chiede riscontri oggettivi sulla condotta dello stesso.`
    },
    {
        id: 'PR03-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR03'],
        text: `Il Mandante dichiara di aver rilevato comportamenti del partner caratterizzati da condotte aggressive, minacciose o intimidatorie, tali da incidere in modo concreto sulla serenità e sull’integrità psicofisica del Mandante.`
    },
    {
        id: 'PR03-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR03'],
        text: `Il Mandante riferisce episodi ricorrenti di pressioni, controlli indebiti, condotte intrusive o manipolatorie, anche tramite strumenti di comunicazione (telefonate, messaggi, social), ritenuti potenzialmente lesivi dei propri diritti e della propria libertà personale.`
    },
    {
        id: 'PR03-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR03'],
        text: `Il Mandante segnala la presenza di circostanze specifiche, documentabili o riscontrabili (es. testimoni, comunicazioni, episodi circostanziati), dalle quali emergono profili di possibile illiceità o scorrettezza nella condotta del partner, meritevoli di approfondimento.`
    },
    {
        id: 'PR03-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR03'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, nel loro complesso, fanno sorgere un fondato sospetto circa condotte del partner potenzialmente lesive dei diritti e dell’integrità psicofisica del Mandante, rendendo necessario acquisire riscontri oggettivi.`
    },
    {
        id: 'PR03-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR03'],
        text: `Il Mandante dichiara che, con riferimento al partner __________________, a partire da __________________, si sono verificati i seguenti fatti: __________________ (es. minacce, pressioni, controlli, aggressività, molestie, condotte intrusive), tuttora in corso / ripetuti nel tempo, e chiede di acquisire riscontri oggettivi sulla relativa condotta.`
    },
    {
        id: 'PR04-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR04'],
        text: `Il Mandante, esercente la responsabilità genitoriale, dichiara di aver rilevato nel minore segnali di disagio in coincidenza con i periodi di permanenza presso l’altro genitore (es. alterazioni dell’umore, timori, regressioni, irritabilità, rifiuto di andare), ritenuti meritevoli di approfondimento.`
    },
    {
        id: 'PR04-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR04'],
        text: `Il Mandante riferisce di aver ricevuto segnalazioni e/o di aver riscontrato circostanze compatibili con abitudini o frequentazioni dell’altro genitore potenzialmente non idonee (es. ambienti inadeguati, frequentazioni improprie, abuso di alcol, possibile uso di sostanze), con possibile riflesso pregiudizievole sul minore.`
    },
    {
        id: 'PR04-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR04'],
        text: `Il Mandante segnala episodi circostanziati (date, luoghi, condotte) dai quali emergerebbero profili di trascuratezza, inadeguata vigilanza o comportamenti comunque non conformi al miglior interesse del minore, rendendo necessario acquisire riscontri oggettivi sulla gestione quotidiana durante i periodi di affidamento/permanenza.`
    },
    {
        id: 'PR04-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR04'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la condotta dell’altro genitore e l’idoneità dell’ambiente di permanenza del minore, richiedendo accertamenti investigativi finalizzati alla tutela del superiore interesse del minore.`
    },
    {
        id: 'PR04-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR04'],
        text: `Il Mandante dichiara che, durante i periodi di permanenza del minore presso __________________, a partire da __________________, ha rilevato i seguenti elementi di fatto: __________________ (es. disagio del minore, frequentazioni/ambienti non idonei, trascuratezza, abuso di alcol/sostanze, assenze di vigilanza), e chiede riscontri oggettivi sulla condotta dell’altro genitore.`
    },
    {
        id: 'PR05-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR05'],
        text: `Il Mandante, esercente la responsabilità genitoriale, dichiara di aver rilevato cambiamenti significativi nel comportamento del minore/giovane (es. chiusura relazionale, irritabilità, calo del rendimento scolastico, assenze ingiustificate), tali da far sorgere fondati timori circa frequentazioni o abitudini a rischio.`
    },
    {
        id: 'PR05-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR05'],
        text: `Il Mandante riferisce di aver appreso, anche da segnalazioni di terzi (es. scuola, parenti, conoscenti), possibili frequentazioni improprie e/o episodi riconducibili ad abuso di alcol o uso di sostanze, ritenuti meritevoli di riscontro oggettivo.`
    },
    {
        id: 'PR05-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR05'],
        text: `Il Mandante segnala di aver riscontrato condotte incompatibili con la regolare frequenza scolastica e/o con la normale routine (es. uscite in orari anomali, rientri tardivi, irreperibilità), con conseguente necessità di verificare luoghi abitualmente frequentati e contesti relazionali.`
    },
    {
        id: 'PR05-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR05'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, valutati nel loro complesso, fanno sorgere fondati dubbi circa condotte a rischio del minore/giovane, richiedendo accertamenti investigativi a supporto dell’esercizio della responsabilità genitoriale e della tutela del minore.`
    },
    {
        id: 'PR05-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR05'],
        text: `Il Mandante dichiara che, con riferimento al minore/giovane __________________, a partire da __________________, ha rilevato i seguenti elementi di fatto: __________________ (es. assenze scolastiche, rientri anomali, cattive frequentazioni, abuso di alcol/sostanze, irreperibilità), e chiede riscontri oggettivi su abitudini e frequentazioni.`
    },
    {
        id: 'PR06-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR06'],
        text: `Il Mandante dichiara di essere destinatario di contatti indesiderati e reiterati (telefonate, messaggi, email, comunicazioni via social), nonché di comportamenti insistenti e intrusivi, tali da generare uno stato di ansia e timore e da incidere sulla normale vita quotidiana.`
    },
    {
        id: 'PR06-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR06'],
        text: `Il Mandante riferisce di aver rilevato appostamenti, pedinamenti o presenze ricorrenti del soggetto di interesse in prossimità della propria abitazione, luogo di lavoro o altri luoghi abitualmente frequentati, con conseguente percezione di rischio per la propria incolumità e libertà di movimento.`
    },
    {
        id: 'PR06-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR06'],
        text: `Il Mandante segnala episodi circostanziati di minacce, intimidazioni o molestie, anche in forma indiretta (tramite terzi o canali digitali), ritenuti meritevoli di riscontro oggettivo e di documentazione ai fini di eventuale tutela in sede civile e/o penale.`
    },
    {
        id: 'PR06-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR06'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, valutati nel loro complesso, fanno sorgere un fondato timore di condotte persecutorie, moleste o minacciose nei propri confronti, rendendo necessario acquisire riscontri oggettivi e documentazione probatoria.`
    },
    {
        id: 'PR06-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR06'],
        text: `Il Mandante dichiara che, a partire da __________________, ha subito i seguenti comportamenti: __________________ (es. contatti ripetuti, appostamenti, pedinamenti, minacce, molestie), verificatisi in __________________ (luoghi) con frequenza __________________, e chiede di documentarne natura, tempi e modalità.`
    },
    {
        id: 'PR07-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR07'],
        text: `Il Mandante dichiara di subire, da parte del soggetto di interesse, condotte reiterate di pressione, intimidazione o svilimento, poste in essere in ambito familiare/personale/lavorativo, tali da incidere sulla serenità e sul benessere psicologico del Mandante.`
    },
    {
        id: 'PR07-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR07'],
        text: `Il Mandante riferisce episodi ricorrenti di controllo, interferenza o intrusione nella propria sfera privata e/o professionale (es. contatti insistenti, richieste indebite, condotte di sorveglianza, diffusione di informazioni), ritenuti potenzialmente lesivi dei propri diritti e della propria libertà di autodeterminazione.`
    },
    {
        id: 'PR07-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR07'],
        text: `Il Mandante segnala fatti specifici, riscontrabili anche tramite comunicazioni (messaggi, email, chat) o testimonianze, dai quali emergerebbero condotte intimidatorie, denigratorie o comunque idonee a determinare un clima di soggezione o condizionamento, meritevoli di documentazione oggettiva.`
    },
    {
        id: 'PR07-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR07'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, valutati nel loro complesso, fanno sorgere fondati dubbi circa condotte vessatorie o psicologicamente pregiudizievoli poste in essere nei propri confronti, rendendo necessario acquisire riscontri oggettivi e documentazione probatoria.`
    },
    {
        id: 'PR07-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR07'],
        text: `Il Mandante dichiara che, con riferimento al soggetto __________________, a partire da __________________, si sono verificati i seguenti comportamenti: __________________ (es. intimidazioni, pressioni, controlli, denigrazione, intrusioni), in __________________ (luoghi/contesto), e chiede di documentarne tempi, modalità e ricorrenza.`
    },
    {
        id: 'PR08-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR08'],
        text: `Il Mandante, esercente la responsabilità genitoriale, dichiara che il minore ha manifestato segnali di disagio rilevanti (es. ansia, ritiro sociale, rifiuto della scuola, alterazioni del sonno o dell’umore), compatibili con possibili episodi di bullismo e meritevoli di riscontro.`
    },
    {
        id: 'PR08-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR08'],
        text: `Il Mandante riferisce di essere venuto a conoscenza di comportamenti vessatori, denigratori o aggressivi posti in essere da coetanei (anche in ambito scolastico), nonché di possibili minacce o umiliazioni, con necessità di documentarne natura, tempi e modalità.`
    },
    {
        id: 'PR08-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR08'],
        text: `Il Mandante segnala la presenza di contenuti digitali offensivi o lesivi (messaggi, chat, post, immagini, video, profili falsi), e/o di segnalazioni da parte della scuola o di terzi, ritenuti riconducibili a cyberbullismo, richiedendo acquisizione e conservazione di riscontri oggettivi.`
    },
    {
        id: 'PR08-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR08'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato sospetto circa condotte di bullismo e/o cyberbullismo ai danni del minore, rendendo necessario acquisire riscontri oggettivi, individuare i soggetti coinvolti e ricostruire le dinamiche rilevanti ai fini di tutela.`
    },
    {
        id: 'PR08-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR08'],
        text: `Il Mandante dichiara che, con riferimento al minore __________________, a partire da __________________, sono emersi i seguenti elementi di fatto: __________________ (es. episodi a scuola, aggressioni, minacce, messaggi/post offensivi, profili falsi), in __________________ (contesto/luoghi/piattaforme), e chiede di documentare i fatti e individuare i soggetti coinvolti.`
    },
    {
        id: 'PR09-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR09'],
        text: `Il Mandante dichiara di aver rilevato incongruenze tra le informazioni rese dal soggetto di interesse e riscontri di fatto (es. situazione lavorativa, disponibilità economiche, residenza/dimora, precedenti relazioni), tali da rendere necessario un approfondimento prudenziale prima di assumere impegni personali e patrimoniali.`
    },
    {
        id: 'PR09-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR09'],
        text: `Il Mandante riferisce che il soggetto di interesse ha richiesto o sollecitato contributi economici, intestazioni, garanzie o altre operazioni patrimoniali, ovvero ha manifestato comportamenti idonei a far sorgere dubbi circa affidabilità e trasparenza, con conseguente esigenza di verifiche preventive.`
    },
    {
        id: 'PR09-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR09'],
        text: `Il Mandante segnala di aver ricevuto informazioni o segnalazioni da terzi circa possibili criticità (es. debiti, contenziosi, condotte non dichiarate, rapporti pregressi rilevanti), ritenute meritevoli di riscontro oggettivo e documentale per la tutela del proprio patrimonio.`
    },
    {
        id: 'PR09-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR09'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a verificare, mediante ricerche documentali e riscontri leciti, la reale situazione personale, relazionale ed economica del soggetto di interesse, in vista di scelte di vita e impegni patrimoniali potenzialmente rilevanti.`
    },
    {
        id: 'PR09-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR09'],
        text: `Il Mandante dichiara che, con riferimento a __________________, a partire da __________________, ha rilevato le seguenti incongruenze/segnalazioni: __________________ (es. lavoro/reddito, debiti, residenza, richieste economiche, contenziosi), e chiede di acquisire riscontri oggettivi e documentali sulla reale situazione personale ed economica del soggetto.`
    },
    {
        id: 'PR10-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR10'],
        text: `Il Mandante dichiara di aver rilevato che l’ex coniuge intrattiene da tempo una relazione stabile e frequenta con regolarità l’abitazione di un nuovo partner, con permanenze prolungate e ricorrenti, tali da far ritenere possibile l’instaurazione di una convivenza di fatto.`
    },
    {
        id: 'PR10-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR10'],
        text: `Il Mandante riferisce di aver riscontrato indici oggettivi compatibili con una coabitazione stabile (es. rientri abituali presso il medesimo indirizzo, presenza continuativa in fasce serali/notturne e nei giorni festivi, utilizzo del medesimo domicilio come centro di interessi quotidiani), rilevanti ai fini della revisione delle condizioni di separazione.`
    },
    {
        id: 'PR10-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR10'],
        text: `Il Mandante segnala circostanze e/o informazioni (anche confidenziali) dalle quali emergerebbe una gestione comune della vita quotidiana con il nuovo partner (es. spostamenti e attività condivise, permanenza continuativa, eventuale partecipazione a spese o gestione domestica), meritevoli di riscontro probatorio.`
    },
    {
        id: 'PR10-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR10'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato sospetto circa la sussistenza di una convivenza di fatto stabile e continuativa dell’ex coniuge con un nuovo partner, circostanza rilevante ai fini della rivalutazione degli accordi e delle condizioni economiche in sede di separazione.`
    },
    {
        id: 'PR10-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR10'],
        text: `Il Mandante dichiara che, con riferimento all’ex coniuge __________________, a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. permanenze presso __________________, rientri serali/notturni, presenza continuativa nei festivi, gestione vita quotidiana), e chiede di accertare sussistenza, stabilità e continuità di una convivenza di fatto.`
    },
    {
        id: 'PR11-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR11'],
        text: `Il Mandante, esercente la responsabilità genitoriale, dichiara di aver rilevato nel minore segnali di disagio o regressione in concomitanza o a seguito dei periodi di permanenza presso l’altro genitore (es. ansia, timori, irritabilità, disturbi del sonno, rifiuto), ritenuti meritevoli di approfondimento ai fini di tutela.`
    },
    {
        id: 'PR11-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR11'],
        text: `Il Mandante riferisce di aver appreso, anche tramite segnalazioni di terzi (es. scuola, pediatra, parenti, conoscenti), possibili condotte o abitudini dell’altro genitore e/o del suo contesto familiare (es. frequenti assenze, scarsa vigilanza, ambienti non idonei, conflittualità, abuso di alcol) potenzialmente pregiudizievoli per il minore.`
    },
    {
        id: 'PR11-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR11'],
        text: `Il Mandante segnala episodi circostanziati dai quali emergerebbero profili di inadeguatezza nella gestione quotidiana del minore (es. trascuratezza, mancata cura/igiene, mancato rispetto di routine scolastiche o sanitarie, esposizione a litigi o situazioni critiche), con necessità di raccogliere riscontri oggettivi utili a future valutazioni tecniche.`
    },
    {
        id: 'PR11-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR11'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la condotta e/o il contesto di vita dell’altro genitore durante i periodi di permanenza del minore, e richiede di acquisire riscontri oggettivi e documentabili, utilizzabili anche in eventuale sede tecnica (CTU/CTP) e/o giudiziaria.`
    },
    {
        id: 'PR11-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR11'],
        text: `Il Mandante dichiara che, con riferimento all’altro genitore __________________, a partire da __________________, ha rilevato/ha ricevuto le seguenti segnalazioni: __________________ (es. trascuratezza, ambienti non idonei, scarsa vigilanza, abuso alcol/sostanze, conflittualità), con riflessi sul minore __________________ (descrivere), e chiede di raccogliere elementi oggettivi utili a valutazioni tecniche (CTU/CTP) e/o giudiziarie.`
    },
    {
        id: 'PR12-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR12'],
        text: `Il Mandante dichiara che la persona di interesse risulta irreperibile da __________________, nonostante ripetuti tentativi di contatto e verifiche informali, e che l’assenza di notizie appare anomala rispetto alle consuetudini e alle abitudini pregresse.`
    },
    {
        id: 'PR12-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR12'],
        text: `Il Mandante riferisce che l’irreperibilità incide su interessi giuridicamente rilevanti (es. rapporti familiari, esigenze di tutela personale, necessità di comunicazioni formali, gestione di obbligazioni o impegni), rendendo necessario un rintraccio mediante riscontri leciti.`
    },
    {
        id: 'PR12-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR12'],
        text: `Il Mandante segnala che, prima dell’irreperibilità, si sono verificati elementi o circostanze di possibile criticità (es. conflittualità, fragilità, problemi economici, frequentazioni, spostamenti improvvisi, dichiarazioni preoccupanti) tali da giustificare un’attività di ricerca e verifica.`
    },
    {
        id: 'PR12-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR12'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a rintracciare la persona attualmente irreperibile, al fine di tutela di diritti e interessi giuridicamente rilevanti, richiedendo accertamenti e riscontri esclusivamente con modalità e fonti lecite.`
    },
    {
        id: 'PR12-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR12'],
        text: `Il Mandante dichiara che __________________ (nome/cognome) risulta irreperibile dal __________________; ultimi contatti/avvistamenti __________________; tentativi di contatto effettuati __________________; motivi e interessi alla ricerca __________________; e chiede di acquisire informazioni e riscontri leciti finalizzati al rintraccio, nel rispetto delle regole sulla comunicazione della localizzazione in caso di allontanamento volontario.`
    },
    {
        id: 'PR13-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR13'],
        text: `Il Mandante dichiara di essere titolare di un credito certo e/o documentato nei confronti del soggetto di interesse, rimasto insoluto nonostante solleciti e richieste di pagamento, con conseguente necessità di accertare recapiti attuali e reperibilità del debitore.`
    },
    {
        id: 'PR13-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR13'],
        text: `Il Mandante riferisce che il debitore risulta di fatto difficilmente rintracciabile (irreperibilità ai recapiti noti, trasferimenti frequenti, mancata risposta), e che tale condotta ostacola la tutela del credito e l’eventuale avvio di iniziative stragiudiziali o giudiziarie.`
    },
    {
        id: 'PR13-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR13'],
        text: `Il Mandante segnala incongruenze tra quanto dichiarato dal debitore e riscontri di fatto (es. tenore di vita, disponibilità di beni, attività lavorativa), tali da rendere necessario verificare l’effettiva solvibilità e la capacità patrimoniale in vista di un’azione di recupero.`
    },
    {
        id: 'PR13-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR13'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a rintracciare il debitore e a valutare la sua effettiva capacità economico-patrimoniale, mediante ricerche e riscontri da fonti lecite, al fine di assumere decisioni informate sulla tutela e sul recupero del credito.`
    },
    {
        id: 'PR13-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR13'],
        text: `Il Mandante dichiara di vantare un credito di € __________________ nei confronti di __________________, scaduto in data __________________; solleciti effettuati __________________; recapiti noti/non più validi __________________; e chiede di rintracciare il debitore e acquisire riscontri documentali e oggettivi sulla sua capacità patrimoniale e solvibilità ai fini del recupero del credito.`
    },
    {
        id: 'PR14-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR14'],
        text: `Il Mandante dichiara di dover tutelare un proprio diritto in ambito patrimoniale (es. recupero crediti, obbligazioni economiche, azione giudiziaria, accordi transattivi) e di necessitare di riscontri oggettivi sulla reale capacità economica e solvibilità del soggetto di interesse.`
    },
    {
        id: 'PR14-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR14'],
        text: `Il Mandante riferisce di aver rilevato incongruenze tra le informazioni dichiarate dal soggetto (o risultanti da fonti note) e il tenore di vita osservato, ritenendo necessario verificare la reale situazione reddituale, lavorativa e patrimoniale.`
    },
    {
        id: 'PR14-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR14'],
        text: `Il Mandante segnala che sono emersi elementi di possibile intestazione di beni a terzi, trasferimenti anomali o disponibilità di asset non coerenti con quanto dichiarato, circostanze che rendono opportuno un accertamento documentale e investigativo da fonti lecite.`
    },
    {
        id: 'PR14-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR14'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ricostruire la situazione reddituale, patrimoniale, immobiliare e lavorativa del soggetto di interesse, mediante ricerche e riscontri da fonti lecite, al fine di assumere decisioni informate per la tutela dei propri diritti.`
    },
    {
        id: 'PR14-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR14'],
        text: `Il Mandante dichiara che l’accertamento è richiesto in relazione a __________________ (es. recupero credito/azione civile/assegno/accordo), nei confronti di __________________; elementi emersi/incongruenze __________________; e chiede di ricostruire, con riscontri leciti, la situazione reddituale, patrimoniale, immobiliare e lavorativa del soggetto.`
    },
    {
        id: 'PR15-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR15'],
        text: `Il Mandante dichiara di dover tutelare un proprio diritto in relazione a rapporti economici e/o familiari (es. separazione/affidamento, assegni, obbligazioni, recupero crediti) e di necessitare di riscontri oggettivi sulla reale dimora, composizione del nucleo e condizioni di vita del soggetto di interesse.`
    },
    {
        id: 'PR15-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR15'],
        text: `Il Mandante riferisce che le informazioni attualmente disponibili sulla residenza/domicilio e sulla situazione lavorativa o familiare del soggetto risultano incerte, contraddittorie o non aggiornate, rendendo necessario accertare l’effettiva situazione abitativa e socio-economica.`
    },
    {
        id: 'PR15-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR15'],
        text: `Il Mandante segnala incongruenze tra quanto dichiarato dal soggetto e riscontri di fatto (es. tenore di vita, convivenze non dichiarate, attività lavorativa di fatto, frequentazioni stabili), che rendono opportuno un approfondimento mediante ricerche e riscontri da fonti lecite.`
    },
    {
        id: 'PR15-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR15'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a determinare la reale situazione abitativa, economica, lavorativa e familiare del soggetto di interesse, mediante accertamenti e riscontri leciti, al fine di assumere decisioni informate per la tutela dei propri diritti.`
    },
    {
        id: 'PR15-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR15'],
        text: `Il Mandante dichiara che l’accertamento è richiesto nei confronti di __________________; contesto/finalità __________________ (es. assegno, affidamento, obbligazioni, credito); elementi di incertezza/incongruenze __________________; e chiede di accertare dimora effettiva, situazione lavorativa, condizioni economiche e nucleo familiare del soggetto.`
    },
    {
        id: 'PR16-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR16'],
        text: `Il Mandante dichiara di aver rilevato anomalie nello svolgimento delle mansioni affidate (es. assenze ingiustificate, ritardi ricorrenti, ridotta diligenza, mancata esecuzione di compiti essenziali), tali da far sorgere dubbi sulla correttezza e affidabilità del collaboratore domestico.`
    },
    {
        id: 'PR16-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR16'],
        text: `Il Mandante riferisce di aver riscontrato circostanze potenzialmente pregiudizievoli per la persona assistita e/o per il nucleo familiare (es. gestione inadeguata di minori/anziani, comportamenti negligenti, frequentazioni estranee nell’abitazione, utilizzo non autorizzato di beni), ritenute meritevoli di riscontro oggettivo.`
    },
    {
        id: 'PR16-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR16'],
        text: `Il Mandante segnala episodi specifici o sospetti di condotte illecite o scorrette (es. ammanchi di denaro o oggetti, richieste indebite, trattamenti non adeguati, violazioni di riservatezza), per i quali si richiede verifica e documentazione nei limiti di legge.`
    },
    {
        id: 'PR16-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR16'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la correttezza e l’affidabilità del collaboratore domestico nell’esecuzione delle mansioni affidate, rendendo necessario acquisire riscontri oggettivi a tutela della persona assistita e/o del patrimonio familiare.`
    },
    {
        id: 'PR16-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR16'],
        text: `Il Mandante dichiara che, con riferimento al collaboratore domestico __________________ (ruolo: __________________), a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. assenze, negligenza, frequentazioni estranee, ammanchi, comportamenti inadeguati), e chiede di verificare correttezza, affidabilità e condotta nello svolgimento delle mansioni affidate.`
    },
    {
        id: 'PR17-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR17'],
        text: `Il Mandante dichiara di intrattenere una relazione o frequentazione con soggetto conosciuto anche tramite piattaforme online, del quale dispone di informazioni parziali o non verificabili, e di aver rilevato incongruenze su identità, residenza, lavoro o situazione personale.`
    },
    {
        id: 'PR17-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR17'],
        text: `Il Mandante riferisce che il soggetto di interesse ha richiesto o sollecitato somme di denaro, regali, ricariche, garanzie, accessi o dati personali, ovvero ha assunto condotte manipolative o pressioni emotive, circostanze compatibili con possibili finalità fraudolente e meritevoli di riscontro.`
    },
    {
        id: 'PR17-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR17'],
        text: `Il Mandante segnala di aver riscontrato elementi sospetti (es. profili social incoerenti o duplicati, immagini non riconducibili, numeri/contatti variabili, storie non verificabili, riferimenti a urgenze o emergenze), tali da far sorgere un fondato timore di truffa sentimentale o di altri pregiudizi patrimoniali/personali.`
    },
    {
        id: 'PR17-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR17'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa l’identità, l’attendibilità e la condotta del soggetto conosciuto anche tramite canali online, richiedendo accertamenti investigativi finalizzati alla prevenzione di truffe e alla tutela del proprio patrimonio e della propria integrità psicofisica.`
    },
    {
        id: 'PR17-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR17'],
        text: `Il Mandante dichiara che, con riferimento a __________________ (nome/profilo/contatto), a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. incongruenze identità, richieste di denaro/dati, pressioni, profili sospetti), e chiede di verificare identità, attendibilità e condotta del soggetto al fine di prevenire possibili truffe o pregiudizi.`
    },
    {
        id: 'PR18-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR18'],
        text: `Il Mandante dichiara di aver subito un danno patrimoniale e di aver riscontrato operazioni, pagamenti o movimentazioni anomale (es. addebiti non riconosciuti, ammanchi, utilizzo indebito di denaro/beni), tali da far sorgere il sospetto di condotte fraudolente o appropriazioni indebite.`
    },
    {
        id: 'PR18-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR18'],
        text: `Il Mandante riferisce che il soggetto di interesse ha fornito versioni contraddittorie o non documentate circa l’utilizzo di somme/beni affidati o gestiti, ovvero ha omesso restituzioni o rendicontazioni dovute, rendendo necessario acquisire riscontri oggettivi sui fatti e sulle responsabilità.`
    },
    {
        id: 'PR18-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR18'],
        text: `Il Mandante segnala l’esistenza di circostanze specifiche e riscontrabili (documenti, comunicazioni, testimoni, pagamenti, consegne) dalle quali emergono indizi di artifici o raggiri, distrazioni di beni o altre condotte idonee a cagionare pregiudizio economico, meritevoli di documentazione probatoria.`
    },
    {
        id: 'PR18-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR18'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato sospetto circa condotte fraudolente o comunque idonee a cagionare danni patrimoniali, e richiede l’acquisizione di riscontri oggettivi e mezzi di prova utilizzabili a tutela dei propri diritti.`
    },
    {
        id: 'PR18-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR18'],
        text: `Il Mandante dichiara che, in relazione a __________________ (soggetto/rapporto), nel periodo __________________, si sono verificati i seguenti fatti: __________________ (es. ammanchi, pagamenti anomali, mancata restituzione, raggiri), con danno stimato di € __________________, e chiede di raccogliere elementi probatori relativi alle condotte e alle responsabilità.`
    },
    {
        id: 'PR19-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR19'],
        text: `Il Mandante dichiara di subire da parte di vicini/condomini condotte moleste reiterate (es. rumori e disturbi in fasce orarie critiche, schiamazzi, attività rumorose), tali da incidere sulla vivibilità dell’immobile e sulla serenità della vita familiare.`
    },
    {
        id: 'PR19-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR19'],
        text: `Il Mandante riferisce episodi circostanziati di comportamenti ostili o pregiudizievoli (es. minacce, ingiurie, intimidazioni, danneggiamenti, ostruzioni, molestie), anche con possibile coinvolgimento di aree comuni, ritenuti meritevoli di riscontro oggettivo ai fini di tutela civile/amministrativa.`
    },
    {
        id: 'PR19-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR19'],
        text: `Il Mandante segnala che le condotte lamentate risultano difficilmente documentabili con mezzi ordinari e che, nonostante richiami, segnalazioni o tentativi di mediazione/amministratore, i comportamenti persistono, rendendo necessaria un’attività di documentazione esterna e imparziale.`
    },
    {
        id: 'PR19-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR19'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa condotte moleste o pregiudizievoli in ambito condominiale o di vicinato, e richiede l’acquisizione di riscontri oggettivi e documentazione utile per eventuali iniziative di tutela civile o amministrativa.`
    },
    {
        id: 'PR19-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR19'],
        text: `Il Mandante dichiara che, a partire da __________________, ha subito le seguenti condotte: __________________ (es. rumori, minacce, danneggiamenti, molestie), verificatesi in __________________ (luoghi/aree comuni) con frequenza __________________, e chiede di documentarne tempi, modalità e soggetti coinvolti ai fini di tutela civile/amministrativa.`
    },
    {
        id: 'PR20-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR20'],
        text: `Il Mandante dichiara di aver rilevato comportamenti del soggetto di interesse caratterizzati da atteggiamenti ostili, minacciosi o comunque anomali, tali da generare un fondato timore di possibili condotte pregiudizievoli nei confronti del Mandante e/o dei familiari.`
    },
    {
        id: 'PR20-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR20'],
        text: `Il Mandante riferisce di aver riscontrato frequentazioni, spostamenti o abitudini del soggetto ritenuti potenzialmente a rischio (es. contatti con persone problematiche, presenza in luoghi sensibili, condotte aggressive o impulsive), e chiede di acquisire riscontri oggettivi sul suo stile di vita e sulle condotte rilevanti.`
    },
    {
        id: 'PR20-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR20'],
        text: `Il Mandante segnala episodi circostanziati (date/luoghi) nei quali il soggetto avrebbe posto in essere condotte intrusive o di avvicinamento non gradito (es. appostamenti, pedinamenti, controlli, contatti insistenti), rendendo opportuno un monitoraggio proporzionato e documentabile.`
    },
    {
        id: 'PR20-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR20'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato timore di condotte potenzialmente pregiudizievoli poste in essere dal soggetto di interesse nei confronti del Mandante o dei suoi familiari, e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi su comportamenti, frequentazioni e abitudini.`
    },
    {
        id: 'PR20-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR20'],
        text: `Il Mandante dichiara che, con riferimento a __________________ (soggetto), a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. minacce, avvicinamenti, contatti insistenti, frequentazioni a rischio), verificatisi in __________________ (luoghi/contesto), e chiede di verificare comportamenti, frequentazioni e abitudini potenzialmente pregiudizievoli verso il Mandante e/o i familiari.`
    },
    {
        id: 'PR21-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR21'],
        text: `Il Mandante dichiara di aver rilevato elementi incompatibili con la situazione economica ufficialmente rappresentata dall’ex coniuge/altro genitore (es. tenore di vita, spese, disponibilità di beni, viaggi), tali da far sorgere fondati dubbi sulla reale capacità reddituale e patrimoniale.`
    },
    {
        id: 'PR21-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR21'],
        text: `Il Mandante riferisce di essere venuto a conoscenza di possibili attività lavorative ulteriori o non dichiarate (es. collaborazioni, lavoro “in nero”, attività autonome), ovvero di fonti di reddito non emerse in sede di accordi, rendendo necessario acquisire riscontri oggettivi e documentabili.`
    },
    {
        id: 'PR21-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR21'],
        text: `Il Mandante segnala che, successivamente alla separazione, sarebbero intervenute variazioni rilevanti nella situazione dell’ex coniuge/altro genitore (es. nuova occupazione, incremento redditi, disponibilità di immobili/veicoli, supporto economico da terzi), circostanze idonee a incidere sull’equilibrio degli accordi economici.`
    },
    {
        id: 'PR21-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR21'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la reale situazione lavorativa, reddituale e patrimoniale dell’ex coniuge/altro genitore e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi, anche in relazione a eventuali attività non dichiarate, ai fini della rivalutazione delle condizioni economiche post-separazione.`
    },
    {
        id: 'PR21-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR21'],
        text: `Il Mandante dichiara che, con riferimento a __________________ (ex coniuge/altro genitore), a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. tenore di vita, attività lavorative sospette, beni/immobili, spese), e chiede di accertare la reale situazione lavorativa, reddituale e patrimoniale, anche in relazione a eventuali attività non dichiarate, ai fini della revisione dell’assegno e/o degli accordi economici.`
    },
    {
        id: 'PR22-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR22'],
        text: `Il Mandante dichiara di aver rilevato la pubblicazione e/o diffusione online di contenuti a proprio riferiti (post, commenti, messaggi, recensioni, immagini, video) ritenuti offensivi, denigratori o comunque lesivi dell’onore, reputazione o immagine personale.`
    },
    {
        id: 'PR22-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR22'],
        text: `Il Mandante riferisce che tali contenuti risultano visibili su piattaforme web/social e potenzialmente idonei a determinare un pregiudizio concreto (es. danno d’immagine, ripercussioni personali/lavorative), rendendo necessario procedere alla cristallizzazione del contenuto con riscontri oggettivi (URL, data/ora, screenshot, metadati disponibili).`
    },
    {
        id: 'PR22-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR22'],
        text: `Il Mandante segnala che la diffusione potrebbe essere riconducibile a soggetto noto o ignoto e/o a profili anonimi/falsi, e richiede di ricostruire, per quanto possibile con modalità lecite, l’origine, le modalità di propagazione e gli eventuali canali di ulteriore diffusione.`
    },
    {
        id: 'PR22-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR22'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto relativi alla diffusione online di contenuti ritenuti lesivi della propria reputazione e richiede accertamenti digitali finalizzati alla loro acquisizione e conservazione in forma oggettiva, nonché alla ricostruzione, per quanto possibile, di autore e modalità di diffusione, senza accessi abusivi a sistemi o account.`
    },
    {
        id: 'PR22-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR22'],
        text: `Il Mandante dichiara che, in data __________________, ha rilevato i seguenti contenuti lesivi: __________________, pubblicati su __________________ (piattaforma) al link/account __________________; richiede acquisizione e conservazione dei riscontri (screenshot, URL, data/ora, metadati disponibili) e, per quanto possibile, l’individuazione dell’autore e delle modalità di diffusione con strumenti leciti.`
    },
    {
        id: 'PR90-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR90'],
        text: `Il Mandante dichiara di aver rilevato circostanze e comportamenti anomali riconducibili al soggetto di interesse, potenzialmente idonei a cagionare un pregiudizio alla propria persona e/o al proprio patrimonio (es. minacce, pressioni, indebite interferenze, condotte intrusive).`
    },
    {
        id: 'PR90-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR90'],
        text: `Il Mandante riferisce episodi circostanziati, verificatisi in determinati luoghi e periodi, dai quali emergono profili di possibile illiceità o scorrettezza, e ritiene necessario acquisire riscontri oggettivi e documentabili per valutare e attivare le opportune iniziative di tutela.`
    },
    {
        id: 'PR90-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR90'],
        text: `Il Mandante segnala che le condotte lamentate risultano difficilmente dimostrabili con mezzi ordinari e che la situazione appare in evoluzione e/o reiterata, con conseguente esigenza di verificare modalità, frequenza e contesto delle condotte, anche al fine di prevenire ulteriori danni.`
    },
    {
        id: 'PR90-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR90'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, valutati nel loro complesso, fanno sorgere un fondato sospetto circa comportamenti illeciti o scorretti idonei ad arrecare danno (anche potenziale) alla propria persona e/o al proprio patrimonio, rendendo necessario acquisire riscontri oggettivi e mezzi di prova a tutela dei propri diritti.`
    },
    {
        id: 'PR90-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR90'],
        text: `Il Mandante dichiara che, con riferimento a __________________ (soggetto) e a partire da __________________, si sono verificati i seguenti fatti: __________________ (descrizione sintetica), in __________________ (luoghi/contesto) con frequenza __________________, e chiede di acquisire riscontri oggettivi e mezzi di prova relativi a condotte potenzialmente dannose per la propria persona e/o per il proprio patrimonio.`
    },
    {
        id: 'PR99-EF1',
        category: 'AMBITO PRIVATO',
        label: '1. Elemento 1',
        mandatiCollegati: ['PR99'],
        text: `Il Mandante dichiara di aver rilevato circostanze specifiche e riscontrabili relative a _________________________________, tali da far sorgere un fondato sospetto di condotte potenzialmente lesive dei propri diritti e interessi, meritevoli di verifica.`
    },
    {
        id: 'PR99-EF2',
        category: 'AMBITO PRIVATO',
        label: '2. Elemento 2',
        mandatiCollegati: ['PR99'],
        text: `Il Mandante riferisce che i fatti oggetto di approfondimento si sono verificati indicativamente nel periodo _________________________________ e risultano tuttora in corso / ripetuti nel tempo, con possibile pregiudizio alla propria persona e/o al proprio patrimonio.`
    },
    {
        id: 'PR99-EF3',
        category: 'AMBITO PRIVATO',
        label: '3. Elemento 3',
        mandatiCollegati: ['PR99'],
        text: `Il Mandante segnala che le informazioni e gli elementi attualmente disponibili risultano incompleti o non oggettivamente verificabili con mezzi ordinari, rendendo necessario acquisire riscontri esterni e documentabili in relazione a _________________________________ (luoghi/soggetti/condotte).`
    },
    {
        id: 'PR99-FG',
        category: 'AMBITO PRIVATO',
        label: '4. Formula generica',
        mandatiCollegati: ['PR99'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che giustificano la richiesta di accertamenti investigativi in relazione a quanto indicato nell’oggetto del presente mandato, al fine di acquisire riscontri oggettivi e mezzi di prova utilizzabili a tutela dei propri diritti.`
    },
    {
        id: 'PR99-VC',
        category: 'AMBITO PRIVATO',
        label: '5. Versione da compilare',
        mandatiCollegati: ['PR99'],
        text: `Il Mandante dichiara che, con riferimento a _________________________________ (soggetto/fatto), a partire da _________________________________, ha rilevato i seguenti elementi di fatto: _________________________________; e chiede di svolgere accertamenti investigativi finalizzati a _________________________________ (scopo/riscontro richiesto).`
    },

    // --- AMBITO AZIENDALE ---
    {
        id: 'AZ01-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ01'],
        text: `Il Mandante dichiara di aver rilevato assenze per malattia/infortunio ricorrenti o collocate in prossimità di turni, festività o periodi critici, con andamento anomalo e non coerente con le esigenze organizzative e con la condotta pregressa del dipendente.`
    },
    {
        id: 'AZ01-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ01'],
        text: `Il Mandante riferisce di aver ricevuto segnalazioni interne e/o di aver riscontrato circostanze compatibili con lo svolgimento, da parte del dipendente, di attività lavorative o personali incompatibili con lo stato dichiarato (es. lavori manuali, seconde attività, prestazioni presso terzi) durante l’assenza.`
    },
    {
        id: 'AZ01-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ01'],
        text: `Il Mandante segnala incongruenze tra le limitazioni desumibili dalla certificazione e i comportamenti osservati o riferiti (es. spostamenti, attività fisiche, impegni), tali da far sorgere un fondato sospetto di abuso dell’assenza e rendere necessario un riscontro oggettivo.`
    },
    {
        id: 'AZ01-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ01'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la correttezza del comportamento del dipendente durante i periodi di malattia/infortunio e richiede accertamenti investigativi finalizzati a verificare eventuali condotte incompatibili con lo stato dichiarato, ai fini di tutela organizzativa e giuslavoristica.`
    },
    {
        id: 'AZ01-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ01'],
        text: `Il Mandante dichiara che il dipendente __________________, in forza con mansione __________________, è assente per malattia/infortunio dal __________________ al __________________; elementi rilevati/segnalazioni __________________; e chiede di verificare il comportamento del dipendente nel periodo di assenza al fine di accertare eventuali condotte incompatibili con lo stato dichiarato.`
    },
    {
        id: 'AZ02-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ02'],
        text: `Il Mandante dichiara di aver rilevato comportamenti e circostanze compatibili con lo svolgimento, da parte del dipendente, di attività lavorative ulteriori non comunicate o non autorizzate (es. impegni ricorrenti in orari sensibili, indisponibilità sistematiche, spostamenti non giustificati).`
    },
    {
        id: 'AZ02-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ02'],
        text: `Il Mandante riferisce di aver ricevuto segnalazioni interne/esterne circa la possibile prestazione di attività presso terzi o la gestione di iniziative imprenditoriali personali da parte del dipendente, potenzialmente in conflitto con gli obblighi contrattuali e con l’interesse aziendale.`
    },
    {
        id: 'AZ02-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ02'],
        text: `Il Mandante segnala indizi di possibile concorrenza sleale o violazione dell’obbligo di fedeltà (es. contatti con clienti/fornitori, offerta di servizi analoghi, utilizzo di informazioni o risorse aziendali), circostanze meritevoli di riscontro oggettivo e documentabile.`
    },
    {
        id: 'AZ02-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ02'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa lo svolgimento, da parte del dipendente, di attività lavorative non autorizzate e/o in concorrenza o comunque in violazione degli obblighi di fedeltà e lealtà, e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi.`
    },
    {
        id: 'AZ02-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ02'],
        text: `Il Mandante dichiara che il dipendente __________________ (mansione __________________) avrebbe posto in essere le seguenti condotte sospette: __________________ (es. doppio lavoro, prestazioni presso terzi, contatti con clienti, attività concorrente), nel periodo __________________, e chiede di verificare e documentare eventuali violazioni dell’obbligo di fedeltà e lealtà verso il datore di lavoro.`
    },
    {
        id: 'AZ03-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ03'],
        text: `Il Mandante dichiara di aver riscontrato ammanchi di cassa, differenze inventariali o sparizioni di merce/beni aziendali, emerse da verifiche contabili, controlli di magazzino o riscontri gestionali, non giustificabili con errori ordinari o procedure interne.`
    },
    {
        id: 'AZ03-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ03'],
        text: `Il Mandante riferisce che gli ammanchi si sono verificati con modalità ricorrenti e/o in circostanze specifiche (es. determinati turni, reparti, fasce orarie, accessi limitati), tali da far sorgere il sospetto di condotte dolose e rendere necessario individuare cause e responsabilità.`
    },
    {
        id: 'AZ03-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ03'],
        text: `Il Mandante segnala indizi o segnalazioni interne circa possibili comportamenti anomali di dipendenti/collaboratori (es. accessi non giustificati, movimentazioni sospette, utilizzo improprio di chiavi/credenziali, consegne irregolari), meritevoli di riscontro oggettivo e documentabile.`
    },
    {
        id: 'AZ03-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ03'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la sussistenza di sottrazioni o irregolarità nella gestione di denaro o beni aziendali e richiede accertamenti investigativi finalizzati a chiarire cause, modalità e responsabilità degli ammanchi, a tutela del patrimonio aziendale.`
    },
    {
        id: 'AZ03-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ03'],
        text: `Il Mandante dichiara che, presso __________________ (sede/reparto), nel periodo __________________, sono stati rilevati i seguenti ammanchi/irregolarità: __________________ (importi/merce), con le seguenti circostanze ricorrenti: __________________ (turni/accessi/aree), e chiede di accertare cause, modalità ed eventuali responsabilità.`
    },
    {
        id: 'AZ04-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ04'],
        text: `Il Mandante dichiara di aver rilevato anomalie nell’utilizzo di beni e risorse aziendali affidate al dipendente/collaboratore (es. chilometraggi non coerenti, rifornimenti anomali, utilizzo fuori orario, spese con carte aziendali non giustificate), emerse da controlli interni o report gestionali.`
    },
    {
        id: 'AZ04-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ04'],
        text: `Il Mandante riferisce che i beni aziendali risulterebbero impiegati per finalità personali o estranee all’attività lavorativa (es. spostamenti privati, commissioni non autorizzate, utilizzo da parte di terzi), con possibile danno economico e organizzativo per l’azienda, rendendo necessario un riscontro oggettivo.`
    },
    {
        id: 'AZ04-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ04'],
        text: `Il Mandante segnala segnalazioni interne/esterne e/o circostanze concrete (date, luoghi, orari) compatibili con un uso non autorizzato di veicoli, attrezzature o materiali aziendali, nonché con possibili sottrazioni o manomissioni, meritevoli di verifica e documentazione.`
    },
    {
        id: 'AZ04-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ04'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa l’uso improprio, personale o non autorizzato di beni e risorse aziendali affidate al dipendente/collaboratore e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi sull’effettivo utilizzo.`
    },
    {
        id: 'AZ04-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ04'],
        text: `Il Mandante dichiara che il dipendente/collaboratore __________________ (mansione __________________) ha in uso __________________ (veicolo/attrezzatura/carta) e che nel periodo __________________ sono emerse le seguenti anomalie: __________________ (es. rifornimenti/spese/chilometri/uso fuori orario); chiede di verificare e documentare eventuali utilizzi impropri o non autorizzati.`
    },
    {
        id: 'AZ05-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ05'],
        text: `Il Mandante dichiara che l’ex dipendente è vincolato da specifici obblighi contrattuali di non concorrenza e/o non sollecitazione e riferisce di aver rilevato indizi di svolgimento di attività concorrente (es. avvio collaborazione con competitor, apertura attività analoga, offerta di servizi sovrapponibili).`
    },
    {
        id: 'AZ05-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ05'],
        text: `Il Mandante segnala di aver riscontrato fenomeni anomali di perdita o migrazione di clientela e contatti commerciali in favore di soggetti concorrenti, coincidenti temporalmente con l’uscita dell’ex dipendente e compatibili con condotte di deviazione o storno di clienti.`
    },
    {
        id: 'AZ05-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ05'],
        text: `Il Mandante riferisce segnalazioni interne/esterne o circostanze specifiche (es. comunicazioni a clienti, offerte commerciali, utilizzo di know-how, materiale, listini o contatti aziendali) che fanno sorgere il fondato sospetto di concorrenza sleale o violazione degli obblighi assunti.`
    },
    {
        id: 'AZ05-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ05'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la violazione di obblighi di non concorrenza/non sollecitazione e/o la commissione di condotte di concorrenza sleale da parte dell’ex dipendente, e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi e documentabili.`
    },
    {
        id: 'AZ05-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ05'],
        text: `Il Mandante dichiara che l’ex dipendente __________________ (ruolo __________________) è vincolato da __________________ (patto non concorrenza/non sollecitazione) fino al __________________; elementi emersi __________________ (es. contatti a clienti, nuova attività, offerte concorrenti); e chiede di accertare e documentare eventuali violazioni e condotte di concorrenza sleale.`
    },
    {
        id: 'AZ06-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ06'],
        text: `Il Mandante dichiara di aver riscontrato che informazioni riservate (es. listini, offerte, condizioni economiche, procedure, dati clienti/fornitori, progetti) sono risultate nella disponibilità di terzi senza legittima ragione, circostanza incompatibile con le regole interne di accesso e gestione documentale.`
    },
    {
        id: 'AZ06-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ06'],
        text: `Il Mandante riferisce segnalazioni o riscontri circa l’utilizzo, da parte di dipendenti/collaboratori o ex dipendenti, di documenti o dati aziendali per finalità estranee (es. a vantaggio proprio o di terzi, in ambito concorrente), con conseguente necessità di verificare condotte e modalità di divulgazione.`
    },
    {
        id: 'AZ06-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ06'],
        text: `Il Mandante segnala anomalie nei sistemi e nelle procedure di gestione delle informazioni (es. accessi non giustificati, copie o trasferimenti di file, invii a indirizzi non autorizzati, stampa o prelievo di documentazione), tali da far sorgere un fondato sospetto di violazione dell’obbligo di riservatezza e richiedere riscontri oggettivi.`
    },
    {
        id: 'AZ06-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ06'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la divulgazione o l’utilizzo improprio di informazioni, dati, documenti o know-how aziendale e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi e documentabili, a tutela del patrimonio informativo dell’azienda.`
    },
    {
        id: 'AZ06-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ06'],
        text: `Il Mandante dichiara che, nel periodo __________________, sono emerse le seguenti criticità: __________________ (es. informazioni riservate diffuse, accessi anomali, documenti copiati/inviati), potenzialmente riconducibili a __________________ (soggetto/reparto); e chiede di verificare eventuale divulgazione o utilizzo improprio di dati/documenti/know-how aziendale.`
    },
    {
        id: 'AZ07-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ07'],
        text: `Il Mandante dichiara di aver rilevato un utilizzo dei permessi/congedi con andamento anomalo (es. ricorrenza in specifiche giornate, prossimità a festività/turni, concentrazione su determinati periodi), con impatto significativo sull’organizzazione aziendale e necessità di verifica sulla correttezza dell’impiego.`
    },
    {
        id: 'AZ07-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ07'],
        text: `Il Mandante riferisce segnalazioni interne/esterne e/o circostanze concrete compatibili con lo svolgimento, durante i permessi/congedi, di attività estranee alle finalità dichiarate (es. commissioni personali prolungate, attività lavorativa presso terzi, spostamenti non coerenti con assistenza), meritevoli di riscontro oggettivo.`
    },
    {
        id: 'AZ07-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ07'],
        text: `Il Mandante segnala incongruenze tra quanto comunicato dal dipendente e riscontri di fatto (es. irreperibilità, mancata presenza presso il soggetto assistito, permanenze in luoghi non pertinenti), tali da far sorgere un fondato sospetto di abuso o utilizzo fraudolento dei permessi.`
    },
    {
        id: 'AZ07-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ07'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa il corretto utilizzo di permessi e/o congedi (ivi inclusi quelli ex L. 104/1992) e richiede accertamenti investigativi finalizzati a verificare l’eventuale sussistenza di condotte abusive o fraudolente, nel rispetto della normativa vigente.`
    },
    {
        id: 'AZ07-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ07'],
        text: `Il Mandante dichiara che il dipendente __________________ (mansione __________________) ha fruito di permessi/congedi (tipologia: __________________) nel periodo __________________; elementi emersi/segnalazioni __________________; e chiede di accertare il corretto utilizzo dei permessi/congedi e l’eventuale sussistenza di condotte abusive o fraudolente.`
    },
    {
        id: 'AZ08-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ08'],
        text: `Il Mandante dichiara che, in relazione all’evento denunciato e/o alla richiesta risarcitoria, sono emerse incongruenze tra la dinamica dichiarata, le circostanze di tempo e luogo e gli elementi oggettivi disponibili (es. turni, presenze, testimonianze, documentazione), tali da far sorgere dubbi sulla veridicità dei fatti.`
    },
    {
        id: 'AZ08-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ08'],
        text: `Il Mandante riferisce che l’evento presenta profili atipici o elementi anomali (es. assenza di riscontri immediati, contraddizioni nelle dichiarazioni, ritardi nella segnalazione, reiterazione di eventi simili), compatibili con possibili finalità strumentali e meritevoli di verifica.`
    },
    {
        id: 'AZ08-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ08'],
        text: `Il Mandante segnala segnalazioni interne/esterne o circostanze concrete compatibili con lo svolgimento, da parte del soggetto di interesse, di attività o comportamenti incompatibili con le lesioni/dichiarazioni rese, o comunque idonei a ridimensionare o smentire la dinamica prospettata.`
    },
    {
        id: 'AZ08-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ08'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la reale dinamica di eventi denunciati e/o la fondatezza di richieste risarcitorie e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi utili a verificare eventuali profili fraudolenti o strumentali.`
    },
    {
        id: 'AZ08-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ08'],
        text: `Il Mandante dichiara che l’evento denunciato in data __________________ (luogo __________________) da __________________ presenta le seguenti incongruenze/anomalie: __________________; richiesta risarcitoria/posizione assicurativa __________________; e chiede di verificare la reale dinamica e di acquisire riscontri oggettivi in ordine a eventuali profili fraudolenti o strumentali.`
    },
    {
        id: 'AZ09-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ09'],
        text: `Il Mandante dichiara che la posizione oggetto di valutazione è di natura apicale, fiduciaria o comunque sensibile (es. gestione finanza, accesso a dati riservati, poteri di firma, rapporti con clienti/fornitori) e che risulta necessario un controllo di affidabilità e reputazione prima dell’instaurazione o prosecuzione del rapporto.`
    },
    {
        id: 'AZ09-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ09'],
        text: `Il Mandante riferisce che, in fase di selezione o durante il rapporto, sono emersi elementi di incertezza o incongruenze nelle informazioni fornite dal candidato/soggetto (es. curriculum, esperienze, incarichi, motivi di cessazione, referenze), tali da rendere opportuni riscontri oggettivi e documentali da fonti lecite.`
    },
    {
        id: 'AZ09-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ09'],
        text: `Il Mandante segnala di aver ricevuto segnalazioni, anche confidenziali, circa possibili criticità reputazionali o comportamentali del soggetto (es. conflitti d’interesse, contenziosi, inaffidabilità, condotte scorrette), ritenute meritevoli di verifica ai fini della tutela dell’azienda.`
    },
    {
        id: 'AZ09-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ09'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto ad acquisire informazioni e riscontri leciti sull’affidabilità, integrità e reputazione del candidato/soggetto destinato a ruolo fiduciario o sensibile, al fine di assumere una decisione consapevole sull’instaurazione o prosecuzione del rapporto.`
    },
    {
        id: 'AZ09-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ09'],
        text: `Il Mandante dichiara che il candidato/soggetto __________________ è valutato per il ruolo __________________ (motivazione: posizione fiduciaria/sensibile); elementi dubbi/incongruenze/segnalazioni __________________; e chiede di acquisire, da fonti lecite, informazioni e riscontri oggettivi su affidabilità e reputazione ai fini della decisione aziendale.`
    },
    {
        id: 'AZ10-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ10'],
        text: `Il Mandante dichiara che la controparte commerciale riveste carattere strategico (per volumi, continuità o rilevanza economica) e che, prima di avviare/proseguire il rapporto, è necessario verificare solidità, operatività reale e affidabilità complessiva, al fine di ridurre rischi di inadempimento e pregiudizi economici.`
    },
    {
        id: 'AZ10-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ10'],
        text: `Il Mandante riferisce che sono emersi segnali di criticità (es. ritardi nei pagamenti, anomalie nelle consegne, informazioni societarie discordanti, variazioni improvvise di sede/assetto, difficoltà di contatto), tali da far sorgere dubbi sulla reale capacità operativa o finanziaria della controparte.`
    },
    {
        id: 'AZ10-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ10'],
        text: `Il Mandante segnala di aver ricevuto segnalazioni o riscontri (anche confidenziali) circa possibili problemi reputazionali, contenziosi, irregolarità o condotte non trasparenti della controparte, rendendo opportuno un approfondimento mediante ricerche e riscontri leciti.`
    },
    {
        id: 'AZ10-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ10'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a verificare, mediante ricerche documentali e riscontri da fonti lecite, l’affidabilità, la solidità e l’operatività reale della controparte commerciale, al fine di assumere decisioni informate e tutelare i propri interessi economici.`
    },
    {
        id: 'AZ10-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ10'],
        text: `Il Mandante dichiara che intende avviare/proseguire un rapporto con __________________ (società/impresa) per __________________ (fornitura/appalto/servizio), con esposizione economica stimata di € __________________; elementi di criticità/segnalazioni __________________; e chiede di verificare affidabilità, solidità e operatività reale della controparte tramite fonti lecite.`
    },
    {
        id: 'AZ11-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ11'],
        text: `Il Mandante dichiara di aver riscontrato anomalie nei risultati commerciali e nelle dinamiche di acquisizione/gestione clienti (es. calo improvviso di ordini, perdita di clienti storici, segnalazioni di offerte concorrenti), compatibili con possibili condotte di deviazione di clientela da parte dell’agente/procacciatore/concessionario.`
    },
    {
        id: 'AZ11-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ11'],
        text: `Il Mandante riferisce di aver ricevuto segnalazioni da clienti, colleghi o referenti interni circa comportamenti non conformi agli obblighi contrattuali (es. promesse non autorizzate, condizioni difformi, uso improprio del marchio, condotte scorrette), rendendo necessario un riscontro oggettivo e documentabile.`
    },
    {
        id: 'AZ11-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ11'],
        text: `Il Mandante segnala indizi di possibili rapporti paralleli o conflitti d’interesse (es. collaborazione con competitor, canalizzazione di richieste verso terzi, gestione opaca delle trattative), tali da far sorgere un fondato sospetto di violazioni contrattuali o concorrenza sleale.`
    },
    {
        id: 'AZ11-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ11'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa la correttezza della condotta commerciale e professionale dell’agente/procacciatore/concessionario e richiede accertamenti investigativi finalizzati a verificare eventuali violazioni contrattuali e/o deviazione di clientela, acquisendo riscontri oggettivi.`
    },
    {
        id: 'AZ11-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ11'],
        text: `Il Mandante dichiara che __________________ (agente/procacciatore/concessionario), operante nell’area __________________, avrebbe posto in essere le seguenti criticità: __________________ (es. segnalazioni clienti, offerte concorrenti, promesse non autorizzate, deviazione), nel periodo __________________; e chiede di verificare condotta commerciale e accertare eventuali violazioni contrattuali o deviazione di clientela.`
    },
    {
        id: 'AZ12-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ12'],
        text: `Il Mandante dichiara di vantare un credito commerciale documentato nei confronti dell’impresa/ditta di interesse, rimasto insoluto nonostante solleciti e interlocuzioni, e di dover valutare la concreta utilità di azioni stragiudiziali o giudiziarie di recupero.`
    },
    {
        id: 'AZ12-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ12'],
        text: `Il Mandante riferisce che la debitrice ha mostrato segnali di criticità (es. pagamenti discontinui, promesse non mantenute, difficoltà di contatto, cambi frequenti di sede o referenti), tali da far sorgere dubbi sulla reale operatività e sulla capacità di far fronte alle obbligazioni.`
    },
    {
        id: 'AZ12-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ12'],
        text: `Il Mandante segnala incongruenze tra la situazione dichiarata dalla controparte e riscontri di fatto (es. prosecuzione dell’attività nonostante dichiarata crisi, trasferimenti anomali, passaggi a nuove società, intestazioni a terzi), rendendo opportuno ricostruire asset, operatività e possibili elementi utili al recupero.`
    },
    {
        id: 'AZ12-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ12'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ricostruire, mediante ricerche documentali e riscontri leciti, la situazione patrimoniale e operativa dell’impresa/ditta debitrice, al fine di assumere decisioni informate sulle concrete possibilità di recupero del credito e sulle eventuali azioni da intraprendere.`
    },
    {
        id: 'AZ12-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ12'],
        text: `Il Mandante dichiara di vantare un credito di € __________________ verso __________________ (impresa/ditta), scaduto in data __________________; solleciti effettuati __________________; criticità riscontrate __________________; e chiede di ricostruire situazione patrimoniale e operativa della debitrice mediante fonti lecite, al fine di valutare le concrete possibilità di recupero.`
    },
    {
        id: 'AZ13-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ13'],
        text: `Il Mandante dichiara che l’impresa/ditta di interesse risulta difficilmente contattabile ai recapiti ufficiali e/o che presso la sede legale dichiarata non vi è riscontro di effettiva presenza operativa, rendendo necessario individuare sede effettiva e luoghi di svolgimento dell’attività.`
    },
    {
        id: 'AZ13-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ13'],
        text: `Il Mandante riferisce che, nell’ambito di un rapporto commerciale o di un credito da recuperare, sono emerse criticità relative a reperibilità dei referenti, variazioni frequenti di indirizzi, mancanza di trasparenza su rappresentanza e poteri, con conseguente esigenza di identificare i soggetti di riferimento effettivi (legale rappresentante, amministratori di fatto, referenti operativi).`
    },
    {
        id: 'AZ13-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ13'],
        text: `Il Mandante segnala che le informazioni disponibili risultano discordanti o incomplete (es. sedi “di comodo”, intestazioni a soggetti terzi, attività svolta in luoghi diversi da quelli dichiarati), circostanze che rendono opportuno un accertamento documentale e di riscontro sul campo tramite fonti lecite.`
    },
    {
        id: 'AZ13-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ13'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a individuare, mediante ricerche documentali e riscontri leciti, la sede effettiva, i luoghi di operatività reale e i soggetti di riferimento dell’impresa/ditta di interesse, ai fini di tutela commerciale e/o recupero crediti.`
    },
    {
        id: 'AZ13-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ13'],
        text: `Il Mandante dichiara che, in relazione a __________________ (impresa/ditta), sono emerse le seguenti criticità: __________________ (es. sede non operativa, irreperibilità, referenti non chiari), nel periodo __________________; e chiede di individuare sede effettiva, luoghi di operatività e soggetti di riferimento (legale rappresentante/referenti) tramite fonti lecite, ai fini di tutela commerciale e/o recupero crediti.`
    },
    {
        id: 'AZ14-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ14'],
        text: `Il Mandante dichiara di aver rilevato la presenza sul mercato (fisico e/o online) di prodotti che riproducono o imitano in modo confondibile marchi, segni distintivi, packaging o caratteristiche dei propri prodotti, con sospetto di contraffazione e conseguente necessità di riscontri oggettivi.`
    },
    {
        id: 'AZ14-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ14'],
        text: `Il Mandante riferisce segnalazioni da clienti, rivenditori o partner circa offerte, annunci o vendite di merce sospetta, non proveniente dai canali ufficiali, con possibile danno economico e reputazionale, richiedendo l’individuazione dei canali di distribuzione e dei soggetti coinvolti.`
    },
    {
        id: 'AZ14-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ14'],
        text: `Il Mandante segnala anomalie nelle vendite e/o nella filiera (es. prezzi anormalmente bassi, lotti non tracciabili, forniture non autorizzate, ricomparsa di merce non conforme), circostanze idonee a far sorgere un fondato sospetto di violazione di diritti di proprietà intellettuale e di necessità di documentazione probatoria.`
    },
    {
        id: 'AZ14-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ14'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa condotte di contraffazione e/o violazione di diritti di proprietà intellettuale e richiede accertamenti investigativi finalizzati a documentare i fatti e a individuare, per quanto possibile, canali di commercializzazione e soggetti coinvolti, al fine di tutelare i propri diritti.`
    },
    {
        id: 'AZ14-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ14'],
        text: `Il Mandante dichiara che, in relazione a __________________ (marchio/prodotto/segno), ha rilevato i seguenti elementi: __________________ (es. annunci, punti vendita, prezzi anomali, campioni merce), nel periodo __________________ e/o presso __________________; e chiede di accertare e documentare condotte di contraffazione/violazione IP, individuando canali e soggetti coinvolti.`
    },
    {
        id: 'AZ15-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ15'],
        text: `Il Mandante dichiara di aver rilevato anomalie o scostamenti rispetto agli standard contrattualmente previsti (es. qualità del servizio, modalità operative, layout, prezzi/condizioni, procedure, standard di rete), tali da far sorgere dubbi sul corretto adempimento degli obblighi da parte dell’affiliato/appaltatore/partner.`
    },
    {
        id: 'AZ15-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ15'],
        text: `Il Mandante riferisce segnalazioni da clienti, audit interni o riscontri commerciali circa comportamenti non conformi (es. utilizzo improprio del marchio, comunicazioni non autorizzate, offerte difformi, gestione non corretta del punto vendita/servizio), con potenziale danno reputazionale ed economico, richiedendo riscontri oggettivi.`
    },
    {
        id: 'AZ15-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ15'],
        text: `Il Mandante segnala indizi di possibili violazioni contrattuali ulteriori (es. subappalto non autorizzato, impiego di personale non conforme, approvvigionamenti fuori canale, mancato rispetto di clausole di esclusiva o territorialità), circostanze meritevoli di verifica e documentazione.`
    },
    {
        id: 'AZ15-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ15'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere fondati dubbi circa il rispetto degli obblighi contrattuali e degli standard di rete da parte dell’affiliato/franchisee/appaltatore/partner e richiede accertamenti investigativi finalizzati a verificare e documentare l’adempimento, inclusi utilizzo del marchio e modalità operative.`
    },
    {
        id: 'AZ15-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ15'],
        text: `Il Mandante dichiara che __________________ (affiliato/appaltatore/partner), operante in __________________, avrebbe posto in essere le seguenti non conformità: __________________ (es. standard, marchio, procedure, subappalto), nel periodo __________________; e chiede di verificare il rispetto delle condizioni pattuite e degli standard di rete e utilizzo del marchio.`
    },
    {
        id: 'AZ16-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ16'],
        text: `Il Mandante dichiara di aver rilevato la pubblicazione e/o diffusione online di contenuti riferiti all’azienda (recensioni, post, commenti, articoli, video, immagini) ritenuti falsi, denigratori o comunque idonei a ledere l’immagine e la reputazione commerciale.`
    },
    {
        id: 'AZ16-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ16'],
        text: `Il Mandante riferisce che tali contenuti risultano visibili su piattaforme web/social e potenzialmente idonei a determinare un pregiudizio concreto (es. perdita di clienti, calo di richieste, danno reputazionale), rendendo necessaria la cristallizzazione dei contenuti con riscontri oggettivi (URL, data/ora, screenshot, metadati disponibili).`
    },
    {
        id: 'AZ16-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ16'],
        text: `Il Mandante segnala che la diffusione potrebbe essere riconducibile a soggetti noti o ignoti (anche tramite profili anonimi/falsi) e richiede di ricostruire, per quanto possibile con modalità lecite, autori, canali di pubblicazione, modalità di propagazione e portata della diffusione.`
    },
    {
        id: 'AZ16-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ16'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto relativi alla diffusione online di contenuti ritenuti lesivi dell’immagine aziendale e richiede accertamenti digitali finalizzati alla loro acquisizione e conservazione in forma oggettiva, nonché alla ricostruzione, per quanto possibile, di autore, canali e portata della diffusione, senza accessi abusivi a sistemi o account.`
    },
    {
        id: 'AZ16-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ16'],
        text: `Il Mandante dichiara che, in data __________________, ha rilevato i seguenti contenuti lesivi: __________________, pubblicati su __________________ (piattaforma) al link/account __________________; richiede acquisizione e conservazione dei riscontri (screenshot, URL, data/ora, metadati disponibili) e, per quanto possibile, l’individuazione dell’autore e la ricostruzione dei canali/portata della diffusione con strumenti leciti.`
    },
    {
        id: 'AZ90-EF1',
        category: 'AMBITO AZIENDALE',
        label: '1. Elemento 1',
        mandatiCollegati: ['AZ90'],
        text: `Il Mandante dichiara di aver rilevato anomalie, comportamenti e circostanze non coerenti con le procedure interne e con i normali standard operativi, potenzialmente idonei a generare pregiudizio economico, organizzativo o reputazionale per l’azienda.`
    },
    {
        id: 'AZ90-EF2',
        category: 'AMBITO AZIENDALE',
        label: '2. Elemento 2',
        mandatiCollegati: ['AZ90'],
        text: `Il Mandante riferisce di aver ricevuto segnalazioni interne/esterne circa possibili condotte scorrette o illecite poste in essere da dipendenti, collaboratori, partner o terzi (es. violazioni di procedure, appropriazioni, divulgazioni, concorrenza sleale, abusi), meritevoli di riscontro oggettivo e documentabile.`
    },
    {
        id: 'AZ90-EF3',
        category: 'AMBITO AZIENDALE',
        label: '3. Elemento 3',
        mandatiCollegati: ['AZ90'],
        text: `Il Mandante segnala episodi circostanziati (date, luoghi, reparti, soggetti) dai quali emergono profili di rischio per il patrimonio aziendale, l’immagine o la continuità organizzativa (es. ammanchi, uso improprio beni, perdita clientela, non conformità gravi), rendendo necessario un accertamento investigativo proporzionato.`
    },
    {
        id: 'AZ90-FG',
        category: 'AMBITO AZIENDALE',
        label: '4. Formula generica',
        mandatiCollegati: ['AZ90'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che, valutati nel loro complesso, fanno sorgere fondati dubbi circa comportamenti illeciti o scorretti idonei ad arrecare danno al patrimonio, all’immagine o all’organizzazione aziendale, e richiede accertamenti investigativi finalizzati ad acquisire riscontri oggettivi e mezzi di prova a tutela dei propri diritti e interessi.`
    },
    {
        id: 'AZ90-VC',
        category: 'AMBITO AZIENDALE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['AZ90'],
        text: `Il Mandante dichiara che, con riferimento a __________________ (soggetto/area/processo), nel periodo __________________, sono emersi i seguenti fatti/anomalie: __________________; possibili effetti/danni __________________; e chiede di acquisire riscontri oggettivi e mezzi di prova relativi a condotte potenzialmente dannose per patrimonio, immagine o organizzazione aziendale.`
    },

    // --- BONIFICHE ---
    {
        id: 'BF01-EF1',
        category: 'BONIFICHE',
        label: '1. Elemento 1',
        mandatiCollegati: ['BF01'],
        text: `Il Mandante dichiara di aver riscontrato la conoscenza, da parte di terzi non legittimati, di informazioni riservate trattate esclusivamente all’interno dell’immobile (es. conversazioni private, decisioni personali o familiari, dati non divulgati), circostanza idonea a far temere un monitoraggio illecito.`
    },
    {
        id: 'BF01-EF2',
        category: 'BONIFICHE',
        label: '2. Elemento 2',
        mandatiCollegati: ['BF01'],
        text: `Il Mandante riferisce di aver percepito segnali o anomalie nei locali (es. rumori insoliti, interferenze, apparecchiature non riconosciute, manomissioni di prese/cablaggi, oggetti spostati o dispositivi sconosciuti), tali da far sorgere un fondato dubbio circa la presenza di apparati di ascolto, registrazione o ripresa.`
    },
    {
        id: 'BF01-EF3',
        category: 'BONIFICHE',
        label: '3. Elemento 3',
        mandatiCollegati: ['BF01'],
        text: `Il Mandante segnala che, in occasione di incontri o conversazioni riservate svolte nell’immobile, informazioni confidenziali sono successivamente emerse all’esterno in modo non spiegabile con altre fonti, rendendo necessario un controllo tecnico dei locali.`
    },
    {
        id: 'BF01-FG',
        category: 'BONIFICHE',
        label: '4. Formula generica',
        mandatiCollegati: ['BF01'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato timore circa la possibile presenza, nei locali di cui ha piena disponibilità giuridica, di dispositivi di ascolto/registrazione/ripresa o altri apparati di monitoraggio illecito, e richiede una bonifica ambientale con redazione di relazione tecnica.`
    },
    {
        id: 'BF01-VC',
        category: 'BONIFICHE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['BF01'],
        text: `Il Mandante dichiara che, presso l’immobile sito in __________________, nella propria disponibilità giuridica, a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. divulgazione informazioni riservate, rumori/anomalie, sospette manomissioni); e chiede bonifica ambientale finalizzata alla ricerca di eventuali dispositivi di intercettazione/monitoraggio illecito, con relazione tecnica.`
    },
    {
        id: 'BF02-EF1',
        category: 'BONIFICHE',
        label: '1. Elemento 1',
        mandatiCollegati: ['BF02'],
        text: `Il Mandante dichiara di aver riscontrato la divulgazione all’esterno di informazioni aziendali riservate (es. trattative, prezzi, strategie, liste clienti/fornitori, decisioni interne) discusse esclusivamente all’interno dei locali aziendali, circostanza non spiegabile con le normali fonti di comunicazione.`
    },
    {
        id: 'BF02-EF2',
        category: 'BONIFICHE',
        label: '2. Elemento 2',
        mandatiCollegati: ['BF02'],
        text: `Il Mandante riferisce di aver rilevato anomalie o segnali compatibili con possibili attività di monitoraggio illecito (es. interferenze su linee/impianti, dispositivi non riconosciuti, manomissioni di prese/cablaggi, accessi non autorizzati, apparati sospetti in sale riunioni o uffici direzionali).`
    },
    {
        id: 'BF02-EF3',
        category: 'BONIFICHE',
        label: '3. Elemento 3',
        mandatiCollegati: ['BF02'],
        text: `Il Mandante segnala che, in concomitanza con riunioni riservate o incontri confidenziali svolti nei locali indicati, informazioni sensibili sono successivamente emerse presso terzi (competitor, controparti, soggetti esterni), generando un fondato timore di intercettazione o ripresa non autorizzata.`
    },
    {
        id: 'BF02-FG',
        category: 'BONIFICHE',
        label: '4. Formula generica',
        mandatiCollegati: ['BF02'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato timore circa la possibile presenza, nei locali aziendali nella disponibilità giuridica dell’azienda, di dispositivi di ascolto/registrazione/ripresa o altri apparati di monitoraggio illecito, e richiede una bonifica ambientale con redazione di relazione tecnica.`
    },
    {
        id: 'BF02-VC',
        category: 'BONIFICHE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['BF02'],
        text: `Il Mandante dichiara che, presso i locali aziendali siti in __________________, nella piena disponibilità giuridica dell’azienda, a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. fuga di informazioni, interferenze, dispositivi sospetti, manomissioni, accessi non autorizzati); e chiede bonifica ambientale finalizzata alla ricerca di eventuali dispositivi di intercettazione/monitoraggio illecito, con relazione tecnica.`
    },
    {
        id: 'BF03-EF1',
        category: 'BONIFICHE',
        label: '1. Elemento 1',
        mandatiCollegati: ['BF03'],
        text: `Il Mandante dichiara di aver ricevuto da terzi informazioni insolite e/o eccessivamente precise circa i propri spostamenti, soste o tragitti, tali da far sorgere un fondato timore di tracciamento non autorizzato del veicolo.`
    },
    {
        id: 'BF03-EF2',
        category: 'BONIFICHE',
        label: '2. Elemento 2',
        mandatiCollegati: ['BF03'],
        text: `Il Mandante riferisce di aver notato la presenza ricorrente degli stessi veicoli o soggetti lungo i percorsi abituali e/o in prossimità di luoghi frequentati, nonché di aver percepito un possibile controllo sistematico dei movimenti, rendendo opportuno verificare l’eventuale installazione di dispositivi di localizzazione.`
    },
    {
        id: 'BF03-EF3',
        category: 'BONIFICHE',
        label: '3. Elemento 3',
        mandatiCollegati: ['BF03'],
        text: `Il Mandante segnala anomalie o indizi sul mezzo compatibili con manomissioni o installazioni (es. segni sospetti su sottoscocca/vanI tecnici, cablaggi non originali, accessori non riconosciuti, interventi inspiegati), tali da giustificare una verifica tecnica mirata alla ricerca di localizzatori o apparati di monitoraggio.`
    },
    {
        id: 'BF03-FG',
        category: 'BONIFICHE',
        label: '4. Formula generica',
        mandatiCollegati: ['BF03'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato timore circa la possibile presenza, sul veicolo nella propria disponibilità giuridica, di localizzatori GPS o altri dispositivi di tracciamento/monitoraggio illecito e richiede una bonifica tecnica del mezzo con redazione di relazione tecnica.`
    },
    {
        id: 'BF03-VC',
        category: 'BONIFICHE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['BF03'],
        text: `Il Mandante dichiara che, con riferimento al veicolo marca __________________, modello __________________, targa __________________, nella propria disponibilità giuridica, a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. informazioni precise sui movimenti, sospetto pedinamento, segni di manomissione); e chiede bonifica tecnica finalizzata alla ricerca di dispositivi di tracciamento/monitoraggio illecito, con relazione tecnica.`
    },
    {
        id: 'BF04-EF1',
        category: 'BONIFICHE',
        label: '1. Elemento 1',
        mandatiCollegati: ['BF04'],
        text: `Il Mandante dichiara di aver riscontrato sul dispositivo comportamenti anomali e persistenti (es. consumo anomalo di batteria/dati, surriscaldamento, riavvii improvvisi, installazioni/app non riconosciute, notifiche insolite), tali da far sorgere un fondato timore di compromissione o controllo non autorizzato.`
    },
    {
        id: 'BF04-EF2',
        category: 'BONIFICHE',
        label: '2. Elemento 2',
        mandatiCollegati: ['BF04'],
        text: `Il Mandante riferisce che terzi sembrerebbero essere a conoscenza di informazioni, comunicazioni o contenuti che il Mandante ritiene riservati e custoditi sul dispositivo, circostanza idonea a giustificare una verifica tecnica per individuare eventuali indicatori di accessi o monitoraggi illeciti.`
    },
    {
        id: 'BF04-EF3',
        category: 'BONIFICHE',
        label: '3. Elemento 3',
        mandatiCollegati: ['BF04'],
        text: `Il Mandante segnala di trovarsi in una situazione di conflitto personale/familiare/lavorativo con soggetti che potrebbero avere un interesse a monitorare il dispositivo e di aver notato eventi sospetti (es. tentativi di accesso agli account, avvisi di sicurezza, cambi password non richiesti), rendendo necessaria una bonifica tecnica mirata.`
    },
    {
        id: 'BF04-FG',
        category: 'BONIFICHE',
        label: '4. Formula generica',
        mandatiCollegati: ['BF04'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato timore circa la possibile compromissione o il controllo non autorizzato di dispositivi elettronici nella propria disponibilità giuridica e richiede attività tecniche di verifica/bonifica finalizzate a individuare anomalie o indicatori di controllo remoto, con redazione di relazione tecnica, restando escluse attività di accesso abusivo o intercettazione di comunicazioni.`
    },
    {
        id: 'BF04-VC',
        category: 'BONIFICHE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['BF04'],
        text: `Il Mandante dichiara che, con riferimento al dispositivo tipo __________________, marca/modello __________________, S/N __________________ (IMEI/ID __________________), nella propria disponibilità giuridica, a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. app sconosciute, consumi anomali, avvisi sicurezza, conoscenza di terzi di info riservate); e chiede verifica e bonifica tecnica con relazione, con esclusione di accessi abusivi e intercettazioni.`
    },
    {
        id: 'BF90-EF1',
        category: 'BONIFICHE',
        label: '1. Elemento 1',
        mandatiCollegati: ['BF90'],
        text: `Il Mandante dichiara di aver riscontrato la conoscenza, da parte di terzi non legittimati, di informazioni riservate riferibili ad ambienti, veicoli o dispositivi nella propria disponibilità, circostanza idonea a far sorgere un fondato timore di monitoraggio illecito.`
    },
    {
        id: 'BF90-EF2',
        category: 'BONIFICHE',
        label: '2. Elemento 2',
        mandatiCollegati: ['BF90'],
        text: `Il Mandante riferisce di aver notato segnali, anomalie o indizi compatibili con possibili attività di ascolto, ripresa, registrazione, tracciamento o controllo remoto (es. interferenze, dispositivi non riconosciuti, manomissioni, accessi sospetti), tali da giustificare una verifica tecnica.`
    },
    {
        id: 'BF90-EF3',
        category: 'BONIFICHE',
        label: '3. Elemento 3',
        mandatiCollegati: ['BF90'],
        text: `Il Mandante segnala l’esistenza di una situazione di conflittualità personale/familiare/professionale o di rischio concreto (es. contenziosi, trattative riservate, tensioni), nella quale soggetti terzi potrebbero avere interesse a monitorare il Mandante, rendendo opportuno un controllo preventivo degli ambienti/mezzi/dispositivi.`
    },
    {
        id: 'BF90-FG',
        category: 'BONIFICHE',
        label: '4. Formula generica',
        mandatiCollegati: ['BF90'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che fanno sorgere un fondato timore circa la possibile presenza di dispositivi o sistemi di ascolto/registrazione/ripresa/tracciamento o monitoraggio illecito su ambienti, veicoli o dispositivi nella propria disponibilità giuridica e richiede attività di bonifica tecnica e/o ambientale con redazione di relazione tecnica.`
    },
    {
        id: 'BF90-VC',
        category: 'BONIFICHE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['BF90'],
        text: `Il Mandante dichiara che, con riferimento a __________________ (ambiente/veicolo/dispositivo) nella propria disponibilità giuridica, a partire da __________________, ha rilevato i seguenti elementi: __________________ (es. fuga di informazioni, interferenze, anomalie, manomissioni, accessi sospetti); e chiede attività di bonifica tecnica/ambientale finalizzata alla rilevazione di apparati o sistemi di monitoraggio illecito, con relazione tecnica.`
    },
    {
        id: 'BF99-EF1',
        category: 'BONIFICHE',
        label: '1. Elemento 1',
        mandatiCollegati: ['BF99'],
        text: `Il Mandante dichiara di aver riscontrato circostanze anomale relative a _________________________________, tali da far sorgere un fondato timore circa la presenza di dispositivi o sistemi di ascolto/registrazione/ripresa/tracciamento o monitoraggio illecito su beni nella propria disponibilità giuridica.`
    },
    {
        id: 'BF99-EF2',
        category: 'BONIFICHE',
        label: '2. Elemento 2',
        mandatiCollegati: ['BF99'],
        text: `Il Mandante riferisce che informazioni riservate riferibili a _________________________________ (ambiente/mezzo/dispositivo) sono emerse all’esterno senza spiegazioni plausibili, ovvero che sono stati percepiti segnali/anomalie (interferenze, rumori, dispositivi non riconosciuti, manomissioni) meritevoli di verifica tecnica.`
    },
    {
        id: 'BF99-EF3',
        category: 'BONIFICHE',
        label: '3. Elemento 3',
        mandatiCollegati: ['BF99'],
        text: `Il Mandante segnala l’esistenza di un contesto di rischio (es. contenzioso, trattative riservate, conflittualità personale o professionale) e ritiene che soggetti terzi possano avere interesse a monitorare _________________________________, rendendo opportuno un controllo tecnico specialistico.`
    },
    {
        id: 'BF99-FG',
        category: 'BONIFICHE',
        label: '4. Formula generica',
        mandatiCollegati: ['BF99'],
        text: `Il Mandante dichiara di essere in possesso di elementi di fatto che giustificano la richiesta di attività di bonifica tecnica/ambientale in relazione a quanto indicato nell’oggetto del presente mandato, finalizzata alla rilevazione di eventuali apparati o sistemi di monitoraggio illecito, con redazione di relazione tecnica.`
    },
    {
        id: 'BF99-VC',
        category: 'BONIFICHE',
        label: '5. Versione da compilare',
        mandatiCollegati: ['BF99'],
        text: `Il Mandante dichiara che, con riferimento a _________________________________ (bene/luogo/dispositivo) nella propria disponibilità giuridica, a partire da _________________________________, ha rilevato i seguenti elementi: _________________________________; e chiede di svolgere attività tecniche di bonifica/verifica finalizzate a _________________________________, con relazione tecnica (eventuale documentazione fotografica limitata ai soli rilievi tecnici e/o agli apparati rinvenuti).`
    },

    // --- STUDI LEGALI ---
    {
        id: 'LEG-DIF-01',
        category: 'STUDI LEGALI',
        label: '1. Studi Legali',
        mandatiCollegati: ['PR-01', 'PR-02', 'SL-01'],
        text: "Il Mandante (difensore o parte assistita) dichiara che nel procedimento indicato sussistono profili di \n" +
            "fatto non adeguatamente chiariti, in particolare con riferimento alla ricostruzione della dinamica \n" +
            "degli eventi, all’individuazione di soggetti informati sui fatti e alla verifica di eventuali versioni \n" +
            "contrastanti."
    },
    {
        id: 'LEG-DIF-02',
        category: 'STUDI LEGALI',
        label: '2. Studi Legali',
        mandatiCollegati: ['PR-01', 'PR-02', 'SL-02'],
        text: "Il Mandante riferisce che le dichiarazioni rese in atti da controparte o da alcuni soggetti escussi \n" +
            "appaiono parziali, contraddittorie o non riscontrate da adeguata documentazione, rendendo \n" +
            "necessario acquisire ulteriori elementi di fatto a supporto della tesi difensiva. "
    },
    {
        id: 'LEG-DIF-03',
        category: 'STUDI LEGALI',
        label: '3. Studi Legali',
        mandatiCollegati: ['PR-01', 'PR-02', 'SL-03'],
        text: "Il Mandante dichiara che, ai fini della strategia processuale in procedimenti di \n" +
            "separazione/divorzio/affidamento minori, è necessario verificare la condotta quotidiana, le \n" +
            "frequentazioni e il tenore di vita della controparte, al fine di documentare situazioni non emergenti \n" +
            "dagli atti ufficiali."
    },
    {
        id: 'LEG-DIF-04',
        category: 'STUDI LEGALI',
        label: '4. Studi Legali',
        mandatiCollegati: ['PR-01', 'PR-02', 'SL-06'],
        text: "Il Mandante riferisce che, per valutare la reale convenienza di intraprendere o proseguire un’azione \n" +
            "giudiziaria di natura patrimoniale, occorre accertare preliminarmente la capacità economica e la \n" +
            "solvibilità effettiva della controparte."
    },

    // --- CONSULENZE ---
    {
        id: 'CO01-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO01'],
        text: `Il Mandante dichiara di trovarsi in una situazione complessa, caratterizzata da più eventi e informazioni tra loro collegate, rispetto alla quale non dispone di un quadro chiaro e completo e ritiene necessario un inquadramento tecnico-investigativo preliminare.`
    },
    {
        id: 'CO01-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO01'],
        text: `Il Mandante riferisce di essere già in possesso di documentazione e materiali eterogenei (es. messaggi, email, registrazioni, fotografie, relazioni, segnalazioni) ma di non avere le competenze tecniche per valutarne pienamente rilevanza, attendibilità, utilizzabilità e forza probatoria.`
    },
    {
        id: 'CO01-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO01'],
        text: `Il Mandante segnala di aver ricevuto pareri discordanti o incompleti in merito alla propria situazione e chiede un supporto professionale indipendente per individuare rischi, opportunità e possibili percorsi di tutela, anche mediante eventuali sviluppi investigativi leciti.`
    },
    {
        id: 'CO01-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO01'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere una valutazione tecnico-investigativa del caso e della documentazione disponibile, al fine di individuare strategie investigative percorribili e mezzi di prova leciti attivabili per la tutela dei propri diritti.`
    },
    {
        id: 'CO01-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO01'],
        text: `Il Mandante dichiara di trovarsi nella seguente situazione: __________________; elementi già disponibili: __________________ (documenti/materiali); aspetti da chiarire: __________________; e chiede una valutazione tecnica del caso con indicazione delle possibili strategie investigative e dei mezzi di prova leciti attivabili.`
    },
    {
        id: 'CO02-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO02'],
        text: `Il Mandante dichiara di trovarsi in una situazione non univocamente definita, rispetto alla quale sono presenti elementi e segnalazioni non sufficienti per assumere decisioni informate, e richiede un inquadramento generale prima di avviare eventuali attività di indagine.`
    },
    {
        id: 'CO02-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO02'],
        text: `Il Mandante riferisce di avere dubbi sulla percorribilità, proporzionalità e utilità di accertamenti investigativi, nonché sui limiti leciti e sulle alternative possibili, e chiede un orientamento tecnico per definire priorità e strategie.`
    },
    {
        id: 'CO02-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO02'],
        text: `Il Mandante segnala di aver già raccolto alcune evidenze (es. comunicazioni, documenti, testimonianze informali) ma di non riuscire a valutarne l’effettiva rilevanza e chiede un supporto per comprendere se e come integrare i riscontri in modo lecito e utile.`
    },
    {
        id: 'CO02-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO02'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere un inquadramento generale della propria situazione, con valutazione di opportunità, limiti e utilità di eventuali indagini, al fine di orientare le scelte di tutela in modo consapevole e conforme a legge.`
    },
    {
        id: 'CO02-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO02'],
        text: `Il Mandante dichiara che la situazione riguarda __________________ (sintesi) e che allo stato dispone di __________________ (elementi/evidenze); chiede un orientamento tecnico-investigativo su opportunità, limiti e utilità di eventuali indagini e sulle priorità operative da considerare.`
    },
    {
        id: 'CO03-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO03'],
        text: `Il Mandante dichiara di trovarsi in una situazione caratterizzata da condotte e dinamiche relazionali anomale o potenzialmente pericolose (es. escalation di conflitto, controlli, minacce, pressioni), rispetto alle quali ritiene necessario un inquadramento tecnico-criminologico dei rischi.`
    },
    {
        id: 'CO03-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO03'],
        text: `Il Mandante riferisce la presenza di episodi ripetuti o progressivi che generano timore o vulnerabilità (per sé o per terzi), e chiede una valutazione professionale delle condotte descritte, dei possibili scenari evolutivi e delle misure di tutela ragionevolmente attivabili.`
    },
    {
        id: 'CO03-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO03'],
        text: `Il Mandante segnala di disporre di elementi informativi/documentali (es. messaggi, chat, email, registrazioni, segnalazioni) che necessitano di lettura tecnica per comprendere indicatori di rischio e definire un percorso di gestione e tutela conforme e proporzionato.`
    },
    {
        id: 'CO03-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO03'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere una valutazione tecnico-criminologica delle dinamiche e condotte descritte, con analisi dei rischi e indicazione di possibili iniziative di tutela e, ove utile, di eventuali sviluppi investigativi leciti.`
    },
    {
        id: 'CO03-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO03'],
        text: `Il Mandante dichiara che la situazione riguarda __________________ (soggetti/rapporto) e che si sono verificati i seguenti episodi/condotte: __________________; elementi disponibili __________________; e chiede una lettura tecnico-criminologica delle dinamiche, con valutazione dei rischi e indicazione di possibili iniziative di tutela.`
    },
    {
        id: 'CO04-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO04'],
        text: `Il Mandante dichiara di essere già in possesso di documentazione investigativa pregressa (es. relazioni, allegati, fotografie, verbali, report tecnici) e di doverne valutare adeguatezza, completezza e spendibilità in relazione alle finalità di tutela in sede stragiudiziale e/o giudiziaria.`
    },
    {
        id: 'CO04-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO04'],
        text: `Il Mandante riferisce che la documentazione disponibile presenta possibili lacune, incoerenze o aspetti non pienamente chiariti (es. periodi scoperti, mancanza di riscontri su fatti rilevanti, assenza di elementi contestuali), rendendo necessario un esame tecnico per individuare integrazioni utili.`
    },
    {
        id: 'CO04-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO04'],
        text: `Il Mandante segnala che, nel tempo, si sono verificati ulteriori eventi o aggiornamenti non compresi nei fascicoli pregressi, e chiede una valutazione professionale per stabilire se e quali approfondimenti investigativi leciti siano opportuni per completare il quadro probatorio.`
    },
    {
        id: 'CO04-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO04'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere un’analisi tecnico-investigativa della documentazione pregressa, al fine di valutarne completezza, coerenza e utilità probatoria e di individuare eventuali integrazioni lecite necessarie alla tutela dei propri diritti.`
    },
    {
        id: 'CO04-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO04'],
        text: `Il Mandante dichiara di disporre dei seguenti fascicoli/documenti: __________________ (periodo/mandato); criticità percepite: __________________; eventi successivi: __________________; e chiede di esaminare la documentazione investigativa pregressa e valutare completezza e necessità di eventuali integrazioni lecite.`
    },
    {
        id: 'CO05-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO05'],
        text: `Il Mandante dichiara di essere in possesso di registrazioni audio/video rilevanti per la tutela dei propri diritti e di detenerle legittimamente, avendole acquisite in modo lecito, e richiede una trascrizione accurata e una prima analisi dei contenuti ai fini di eventuale utilizzo in sede stragiudiziale o giudiziaria.`
    },
    {
        id: 'CO05-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO05'],
        text: `Il Mandante riferisce che i contenuti delle registrazioni risultano parzialmente di difficile comprensione (es. rumori di fondo, più voci, dialoghi sovrapposti, qualità non ottimale) e che è necessario un lavoro tecnico di ascolto/visione, indicizzazione temporale e sintesi dei passaggi rilevanti.`
    },
    {
        id: 'CO05-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO05'],
        text: `Il Mandante segnala che le registrazioni potrebbero contenere ammissioni, minacce, accordi o elementi fattuali significativi, ma che occorre contestualizzare i contenuti (data/luogo/soggetti) e valutare, in via tecnica, la coerenza con gli altri elementi documentali disponibili.`
    },
    {
        id: 'CO05-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO05'],
        text: `Il Mandante dichiara di detenere legittimamente e di aver acquisito lecitamente registrazioni audio/video che ritiene rilevanti ai fini della tutela dei propri diritti e richiede attività di trascrizione e analisi tecnica dei contenuti, con evidenza dei passaggi significativi e indicizzazione temporale.`
    },
    {
        id: 'CO05-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO05'],
        text: `Il Mandante dichiara di fornire n. ___ registrazione/i audio/video del __________________, relativa/e a __________________; soggetti coinvolti __________________; modalità lecita di acquisizione/detenzione __________________; e chiede trascrizione e analisi, con evidenza dei passaggi rilevanti (timecode) e sintesi tecnica dei contenuti.`
    },
    {
        id: 'CO06-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO06'],
        text: `Il Mandante dichiara di aver riscontrato circostanze anomale o indizi compatibili con possibili attività di monitoraggio illecito (es. fuga di informazioni riservate, interferenze, dispositivi non riconosciuti, accessi sospetti), ma intende procedere prima a una valutazione tecnica preliminare per definire rischio e priorità.`
    },
    {
        id: 'CO06-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO06'],
        text: `Il Mandante riferisce di trovarsi in un contesto di particolare sensibilità o conflittualità (es. contenziosi, trattative riservate, gestione di dati sensibili, tensioni personali/professionali) nel quale terzi potrebbero avere interesse a monitorare ambienti, veicoli o dispositivi, e richiede un inquadramento tecnico del rischio.`
    },
    {
        id: 'CO06-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO06'],
        text: `Il Mandante segnala che desidera adottare misure proporzionate e conformi a legge, valutando opportunità, limiti e utilità di eventuali bonifiche tecniche/ambientali mirate, anche in relazione ai beni effettivamente nella propria disponibilità giuridica.`
    },
    {
        id: 'CO06-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO06'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere una valutazione tecnica preliminare sulla sicurezza e sul rischio di intercettazioni/monitoraggi illeciti, al fine di stabilire se e in quale misura sia opportuno procedere a bonifiche mirate su ambienti, veicoli o dispositivi nella propria disponibilità giuridica.`
    },
    {
        id: 'CO06-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO06'],
        text: `Il Mandante dichiara che la richiesta riguarda __________________ (ambiente/veicolo/dispositivo) e che sono stati rilevati i seguenti indizi/anomalie: __________________; contesto di rischio __________________; e chiede una valutazione tecnica preliminare su sicurezza e rischio intercettazioni, con indicazioni sull’eventuale opportunità di bonifica mirata e sulle priorità operative.`
    },
    {
        id: 'CO90-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO90'],
        text: `Il Mandante dichiara di trovarsi in una situazione non pienamente definita, caratterizzata da elementi e segnalazioni che richiedono un inquadramento tecnico preliminare prima di assumere decisioni operative o legali.`
    },
    {
        id: 'CO90-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO90'],
        text: `Il Mandante riferisce di disporre di alcuni materiali/documenti/informazioni (es. comunicazioni, documenti, segnalazioni) ma di non essere in grado di valutarne correttamente rilevanza, attendibilità e utilizzabilità, e richiede un’analisi professionale.`
    },
    {
        id: 'CO90-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO90'],
        text: `Il Mandante segnala di voler comprendere opportunità, limiti e utilità di eventuali successivi accertamenti investigativi leciti, definendo priorità, rischi e possibili percorsi di tutela in modo proporzionato.`
    },
    {
        id: 'CO90-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO90'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere una consulenza tecnico-investigativa generale in ordine alla propria situazione, al fine di valutare la rilevanza degli elementi disponibili e l’eventuale utilità, fattibilità e priorità di successivi accertamenti investigativi leciti.`
    },
    {
        id: 'CO90-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO90'],
        text: `Il Mandante dichiara che la propria situazione riguarda __________________ (sintesi) e che allo stato dispone di __________________ (elementi/documenti); aspetti da chiarire __________________; e chiede una consulenza tecnica generale per valutare utilità e priorità di eventuali successivi accertamenti investigativi leciti.`
    },
    {
        id: 'CO99-EF1',
        category: 'ATTIVITA DI CONSULENZA',
        label: '1. Elemento 1',
        mandatiCollegati: ['CO99'],
        text: `Il Mandante dichiara che la richiesta di consulenza trae origine da una situazione relativa a _________________________________, rispetto alla quale sono emersi elementi e circostanze che richiedono un inquadramento tecnico preliminare per la tutela dei propri diritti.`
    },
    {
        id: 'CO99-EF2',
        category: 'ATTIVITA DI CONSULENZA',
        label: '2. Elemento 2',
        mandatiCollegati: ['CO99'],
        text: `Il Mandante riferisce di disporre dei seguenti elementi/documenti/informazioni: _________________________________, ma di necessitare di una valutazione professionale circa rilevanza, attendibilità, utilizzabilità e possibili sviluppi leciti.`
    },
    {
        id: 'CO99-EF3',
        category: 'ATTIVITA DI CONSULENZA',
        label: '3. Elemento 3',
        mandatiCollegati: ['CO99'],
        text: `Il Mandante segnala la presenza di aspetti non chiariti o di versioni contrastanti in relazione a _________________________________ e chiede indicazioni su opportunità, limiti e utilità di eventuali accertamenti investigativi o altre iniziative di tutela.`
    },
    {
        id: 'CO99-FG',
        category: 'ATTIVITA DI CONSULENZA',
        label: '4. Formula generica',
        mandatiCollegati: ['CO99'],
        text: `Il Mandante dichiara di avere un interesse attuale e concreto a ottenere una consulenza tecnico-investigativa in relazione a quanto indicato nell’oggetto del presente incarico, al fine di valutare la situazione, la documentazione disponibile e l’eventuale utilità di successivi accertamenti investigativi leciti.`
    },
    {
        id: 'CO99-VC',
        category: 'ATTIVITA DI CONSULENZA',
        label: '5. Versione da compilare',
        mandatiCollegati: ['CO99'],
        text: `Il Mandante dichiara che la situazione riguarda _________________________________; elementi già disponibili _________________________________; criticità/aspetti da chiarire _________________________________; e chiede consulenza tecnico-investigativa finalizzata a _________________________________ (scopo/valutazione richiesta), con indicazione di eventuali sviluppi investigativi leciti.`
    },

    // --- STUDI LEGALI ---
    {
        id: 'LEG-01',
        category: 'STUDI LEGALI',
        label: 'Jolly studi legali ',
        mandatiCollegati: ['PR-01', 'PR-02'],
        text: "Il Mandante (difensore o parte assistita) dichiara che, in relazione al procedimento civile e/o penale \n" +
            "di cui all’oggetto, sussistono profili di fatto non adeguatamente chiariti e/o versioni tra loro \n" +
            "contrastanti, tali da rendere necessario acquisire ulteriori elementi oggettivi a supporto della \n" +
            "strategia difensiva e della tutela dei propri diritti in giudizio. "
    },
    {
        id: 'LEG-02',
        category: 'STUDI LEGALI',
        label: 'Studi legali – da compilare manualmente ',
        mandatiCollegati: ['PR-01', 'PR-02'],
        text: "Il Mandante dichiara che, nel procedimento n. __________________ pendente innanzi a \n" +
            "__________________ (Autorità giudiziaria), risultano non pienamente chiariti i seguenti aspetti: \n" +
            "__________________ (es. dinamica dei fatti, presenza di ulteriori testimoni, attendibilità di \n" +
            "determinate dichiarazioni, effettiva situazione patrimoniale di controparte, condotta quotidiana di \n" +
            "una delle parti, ecc.), in relazione ai quali si ritiene necessaria un’attività investigativa di \n" +
            "approfondimento a supporto dell’attività difensiva. "
    },

    // --- CONSULENZE ---
    {
        id: 'CONS-01',
        category: 'ATTIVITA DI CONSULENZA',
        label: 'Jolly consulenze',
        mandatiCollegati: ['PR-01', 'PR-02'],
        text: "Il Mandante dichiara di trovarsi in una situazione caratterizzata da molteplici eventi, segnalazioni e \n" +
            "informazioni tra loro eterogenee, rispetto alla quale ritiene necessario ottenere un inquadramento \n" +
            "tecnico e una valutazione professionale complessiva, al fine di comprendere se, come e in quale \n" +
            "misura sia opportuno avviare specifiche attività investigative o altre iniziative di tutela. "
    },
    {
        id: 'CONS-02',
        category: 'ATTIVITA DI CONSULENZA',
        label: 'Consulenze – da compilare manualmente ',
        mandatiCollegati: ['PR-01', 'PR-02'],
        text: "Il Mandante dichiara di trovarsi nella seguente situazione: __________________ (descrizione \n" +
            "sintetica dei fatti, dei rapporti coinvolti, dei soggetti interessati), rispetto alla quale ha già raccolto \n" +
            "e/o ricevuto i seguenti elementi: __________________ (es. messaggi, email, registrazioni, \n" +
            "relazioni, segnalazioni verbali, documenti, contenuti online, ecc.) e chiede una valutazione tecnica \n" +
            "in ordine alla loro rilevanza, ai possibili rischi e alle eventuali iniziative di tutela da intraprendere."
    }
];